import { operators } from '@pendo/aggregations';
import { PendoIcon, PendoTooltip, PendoMultiselect, PendoEditableContent, PendoDivider, PendoIconButton, PendoButton, PendoToggle, PendoLoadingIndicator, PendoModal, PendoForm, PendoFormItem, PendoInput, PendoAlert, PendoTag, PendoActionsCell, PendoTable, PendoEmptyState, PendoPopover, PendoCard } from '@pendo/components';
import Vue from 'vue';

var SuggestedPagesLoadEventsAggregation = {
  name: 'Suggested Page Tags Load Events',
  response: () => {
    return {
      location: 'request',
      mimeType: 'application/json'
    };
  },
  build: ({
    appId,
    blacklist,
    sampleDenominator,
    timeSeries,
    includeAnonymous
  }) => {
    // pipeline for create rules with url path
    const pathPipeline = operators.pipeline(operators.unwind('parseUrl.path', {
      index: 'itemIndex'
    }), operators.group(['appId', 'itemIndex', 'parseUrl.path'], operators.groupField('document_title', operators.first('parseUrl.fields._pendo_document_title[0]')), operators.groupField('numLoads', operators.sum('loadsPerUrl')), operators.groupField('samples', operators.list('url'))), operators.evaluate({
      samples: 'if(len(samples) > 5, samples[0:5], samples)'
    }), operators.evaluate({
      numLoads: `numLoads * ${sampleDenominator}`
    }), operators.filter('dynamicProbability(parseUrl.path) == 0'), operators.evaluate({
      suggestedRuleType: '"paths"'
    }));

    // pipeline for creating rules with just fragments (no path or query)
    const fragmentOnlyPipeline = operators.pipeline(operators.filter('len(parseUrl.hashBang) == 0 && len(parseUrl.fragment) > 0'), operators.group(['appId', 'parseUrl.fragment'], operators.groupField('numLoads', operators.sum('loadsPerUrl')), operators.groupField('samples', operators.list('url'))), operators.evaluate({
      samples: 'if(len(samples) > 5, samples[0:5], samples)'
    }), operators.filter('dynamicProbability(parseUrl.fragment) == 0'), operators.evaluate({
      suggestedRuleType: '"fragment"'
    }));

    // pipeline for creating rules with path fragments
    const pathFragmentOnlyPipeline = operators.pipeline(operators.filter('len(parseUrl.hashBang) > 0 && !isNil(parseUrl.pathFragments)'), operators.unwind('parseUrl.pathFragments', {
      index: 'itemIndex'
    }), operators.group(['appId', 'itemIndex', 'parseUrl.pathFragments'], operators.groupField('numLoads', operators.sum('loadsPerUrl')), operators.groupField('samples', operators.list('url'))), operators.evaluate({
      samples: 'if(len(samples) > 5, samples[0:5], samples)'
    }), operators.filter('dynamicProbability(parseUrl.pathFragments) == 0'), operators.evaluate({
      suggestedRuleType: '"pathFragments"'
    }));

    // pipeline for creating rules with query fragments
    const queryFragmentOnlyPipeline = operators.pipeline(operators.filter('len(parseUrl.hashBang) > 0 && !isEmpty(parseUrl.fieldFragments)'), operators.evaluate({
      fieldFragmentKeys: 'keys(parseUrl.fieldFragments)'
    }), operators.unwind('fieldFragmentKeys'), operators.evaluate({
      fieldFragmentVals: 'lookup(parseUrl.fieldFragments, fieldFragmentKeys)'
    }), operators.unwind('fieldFragmentVals'), operators.group(['appId', 'fieldFragmentKeys', 'fieldFragmentVals'], operators.groupField('numLoads', operators.sum('loadsPerUrl')), operators.groupField('samples', operators.list('url'))), operators.evaluate({
      samples: 'if(len(samples) > 5, samples[0:5], samples)'
    }), operators.filter('dynamicProbability(fieldFragmentKeys) == 0'), operators.evaluate({
      suggestedRuleType: '"queryFragments"'
    }));

    // pipeline for creating rules with query params
    const queryParamPipeline = operators.pipeline(operators.filter('!isEmpty(parseUrl.fields)'), operators.evaluate({
      fieldKeys: 'keys(parseUrl.fields)'
    }), operators.unwind('fieldKeys'), operators.evaluate({
      fieldVals: 'lookup(parseUrl.fields, fieldKeys)'
    }), operators.unwind('fieldVals'), operators.group(['appId', 'fieldKeys', 'fieldVals'], operators.groupField('numLoads', operators.sum('loadsPerUrl')), operators.groupField('samples', operators.list('url'))), operators.evaluate({
      samples: 'if(len(samples) > 5, samples[0:5], samples)'
    }), operators.filter('fieldKeys != `pendo-designer` && dynamicProbability(fieldKeys) == 0'), operators.evaluate({
      suggestedRuleType: '"queryParameters"'
    }));
    return operators.pipeline(operators.sources.singleEvents({
      appId,
      blacklist,
      sampleDenominator,
      timeSeries
    }), operators.identified(includeAnonymous), operators.filter('type == `load`'), operators.select({
      url: 'url',
      appId: 'appId'
    }), operators.group(['url', 'appId'], operators.groupField('loadsPerUrl', operators.count(null))), {
      pagesAny: {
        pageMatches: 'url'
      }
    }, operators.filter('pageMatches == false'), operators.sort('-loadsPerUrl'), operators.evaluate({
      parseUrl: 'parseUrl(url)'
    }), operators.fork(pathPipeline, fragmentOnlyPipeline, pathFragmentOnlyPipeline, queryFragmentOnlyPipeline, queryParamPipeline), operators.merge(['appId'], operators.mappings({
      totalLoads: 'totalLoads'
    }), operators.pipeline(operators.sources.singleEvents({
      appId,
      blacklist,
      sampleDenominator,
      timeSeries
    }), operators.identified(includeAnonymous), operators.filter('type == `load`'), operators.select({
      url: 'url',
      appId: 'appId'
    }), operators.group(['appId'], operators.groupField('totalLoads', operators.count(null))), operators.evaluate({
      totalLoads: `totalLoads * ${sampleDenominator}`
    }))), operators.evaluate({
      ratioOfAppLoad: 'numLoads / totalLoads'
    }), operators.sort(['-ratioOfAppLoad', '-numLoads']), operators.limit(300));
  }
};

const TaggingAggregations = {
  SuggestedPagesLoadEventsAggregation
};
var TaggingAggregations$1 = {
  ...TaggingAggregations
};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$g = {
  name: 'CollapseDetails',
  components: {
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTooltip: false
    };
  },
  methods: {
    onExpandClick() {
      this.$emit('onExpandClick');
    },
    onNameClick() {
      this.$emit('onNameClick');
    },
    checkOverflow($event) {
      const {
        scrollWidth,
        clientWidth
      } = $event.target;
      this.showTooltip = scrollWidth > clientWidth;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "collapse-details"
  }, [_c('div', {
    staticClass: "collapse-details--header",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"]) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleClick.apply(null, arguments);
      },
      "mouseover": function ($event) {
        return _vm.checkOverflow($event);
      }
    }
  }, [_c('div', {
    staticClass: "collapse-details--header-left"
  }, [_c('pendo-icon', {
    staticClass: "collapse-details--header-left-icon",
    attrs: {
      "type": _vm.isExpanded ? 'minus-square' : 'plus-square',
      "size": "14"
    },
    on: {
      "click": _vm.onExpandClick
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        arrow: true,
        content: _vm.showTooltip ? _vm.name : null,
        boundariesElement: 'viewport',
        delay: {
          show: 300,
          hide: 0
        }
      },
      expression: "{\n                    arrow: true,\n                    content: showTooltip ? name : null,\n                    boundariesElement: 'viewport',\n                    delay: { show: 300, hide: 0 }\n                }"
    }],
    staticClass: "collapse-details--header-left-name",
    on: {
      "click": _vm.onNameClick
    }
  }, [_vm._v("\n                " + _vm._s(_vm.name) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse-details--header-right"
  }, [_vm._t("headerRight")], 2)]), _vm._v(" "), _vm.isExpanded ? _c('div', {
    staticClass: "collapse-details--expand"
  }, [_vm._t("default")], 2) : _vm._e()]);
};
var __vue_staticRenderFns__$g = [];

/* style */
const __vue_inject_styles__$g = function (inject) {
  if (!inject) return;
  inject("data-v-28c51efd_0", {
    source: ".collapse-details[data-v-28c51efd]{height:40px}.collapse-details--header[data-v-28c51efd]{background-color:#fff;height:40px;padding:0 12px;font-size:14px;font-weight:700;line-height:22px;display:flex;justify-content:space-between;align-items:center;gap:6px;border-top:1px solid #dadce5;border-bottom:1px solid #dadce5}.collapse-details--header[data-v-28c51efd]:hover{background-color:#f8f8f9}.collapse-details--header-left[data-v-28c51efd]{display:flex;align-items:center;gap:8px}.collapse-details--header-left-icon[data-v-28c51efd]{cursor:pointer}.collapse-details--header-left-name[data-v-28c51efd]{width:280px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight:400;color:#128297;cursor:pointer}.collapse-details--header-left-name[data-v-28c51efd]:hover{color:#016479;text-decoration:underline}.collapse-details--header-right[data-v-28c51efd]{display:flex;justify-content:flex-end;align-items:center;gap:8px}.collapse-details--expand[data-v-28c51efd]{background-color:#f8f8f9}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$g = "data-v-28c51efd";
/* module identifier */
const __vue_module_identifier__$g = undefined;
/* functional template */
const __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

const e={attribute:/\[\s*(?:(?<namespace>\*|[-\w\P{ASCII}]*)\|)?(?<name>[-\w\P{ASCII}]+)\s*(?:(?<operator>\W?=)\s*(?<value>.+?)\s*(\s(?<caseSensitive>[iIsS]))?\s*)?\]/gu,id:/#(?<name>[-\w\P{ASCII}]+)/gu,class:/\.(?<name>[-\w\P{ASCII}]+)/gu,comma:/\s*,\s*/g,combinator:/\s*[\s>+~]\s*/g,"pseudo-element":/::(?<name>[-\w\P{ASCII}]+)(?:\((?<argument>¶*)\))?/gu,"pseudo-class":/:(?<name>[-\w\P{ASCII}]+)(?:\((?<argument>¶*)\))?/gu,universal:/(?:(?<namespace>\*|[-\w\P{ASCII}]*)\|)?\*/gu,type:/(?:(?<namespace>\*|[-\w\P{ASCII}]*)\|)?(?<name>[-\w\P{ASCII}]+)/gu},t=new Set(["combinator","comma"]),n=new Set(["not","is","where","has","matches","-moz-any","-webkit-any","nth-child","nth-last-child"]),s=/(?<index>[\dn+-]+)\s+of\s+(?<subtree>.+)/,o={"nth-child":s,"nth-last-child":s},r=t=>{switch(t){case"pseudo-element":case"pseudo-class":return new RegExp(e[t].source.replace("(?<argument>¶*)","(?<argument>.*)"),"gu");default:return e[t]}};function c(e,t){let n=0,s="";for(;t<e.length;t++){const o=e[t];switch(o){case"(":++n;break;case")":--n;}if(s+=o,0===n)return s}return s}function i(n,s=e){if(!n)return [];const o=[n];for(const[e,t]of Object.entries(s))for(let n=0;n<o.length;n++){const s=o[n];if("string"!=typeof s)continue;t.lastIndex=0;const r=t.exec(s);if(!r)continue;const c=r.index-1,i=[],a=r[0],l=s.slice(0,c+1);l&&i.push(l),i.push({...r.groups,type:e,content:a});const u=s.slice(c+a.length+1);u&&i.push(u),o.splice(n,1,...i);}let r=0;for(const e of o)switch(typeof e){case"string":throw new Error(`Unexpected sequence ${e} found at index ${r}`);case"object":r+=e.content.length,e.pos=[r-e.content.length,r],t.has(e.type)&&(e.content=e.content.trim()||" ");}return o}const a=/(['"])([^\\\n]+?)\1/g,l=/\\./g;function u(t,n=e){if(""===(t=t.trim()))return [];const s=[];t=(t=t.replace(l,((e,t)=>(s.push({value:e,offset:t}),"".repeat(e.length))))).replace(a,((e,t,n,o)=>(s.push({value:e,offset:o}),`${t}${"".repeat(n.length)}${t}`)));{let e,n=0;for(;(e=t.indexOf("(",n))>-1;){const o=c(t,e);s.push({value:o,offset:e}),t=`${t.substring(0,e)}(${"¶".repeat(o.length-2)})${t.substring(e+o.length)}`,n=e+o.length;}}const o=i(t,n),u=new Set;for(const e of s.reverse())for(const t of o){const{offset:n,value:s}=e;if(!(t.pos[0]<=n&&n+s.length<=t.pos[1]))continue;const{content:o}=t,r=n-t.pos[0];t.content=o.slice(0,r)+s+o.slice(r+s.length),t.content!==o&&u.add(t);}for(const e of u){const t=r(e.type);if(!t)throw new Error(`Unknown token type: ${e.type}`);t.lastIndex=0;const n=t.exec(e.content);if(!n)throw new Error(`Unable to parse content for ${e.type}: ${e.content}`);Object.assign(e,n.groups);}return o}function f(e,{list:t=!0}={}){if(t&&e.find((e=>"comma"===e.type))){const t=[],n=[];for(let s=0;s<e.length;s++)if("comma"===e[s].type){if(0===n.length)throw new Error("Incorrect comma at "+s);t.push(f(n,{list:!1})),n.length=0;}else n.push(e[s]);if(0===n.length)throw new Error("Trailing comma");return t.push(f(n,{list:!1})),{type:"list",list:t}}for(let t=e.length-1;t>=0;t--){let n=e[t];if("combinator"===n.type){let s=e.slice(0,t),o=e.slice(t+1);return {type:"complex",combinator:n.content,left:f(s),right:f(o)}}}switch(e.length){case 0:throw new Error("Could not build AST.");case 1:return e[0];default:return {type:"compound",list:[...e]}}}function*p(e,t){switch(e.type){case"list":for(let t of e.list)yield*p(t,e);break;case"complex":yield*p(e.left,e),yield*p(e.right,e);break;case"compound":yield*e.list.map((t=>[t,e]));break;default:yield [e,t];}}function m(e,{recursive:t=!0,list:s=!0}={}){const r=u(e);if(!r)return;const c=f(r,{list:s});if(!t)return c;for(const[e]of p(c)){if("pseudo-class"!==e.type||!e.argument)continue;if(!n.has(e.name))continue;let t=e.argument;const s=o[e.name];if(s){const n=s.exec(t);if(!n)continue;Object.assign(e,n.groups),t=n.groups.subtree;}t&&Object.assign(e,{subtree:m(t,{recursive:!0,list:!0})});}return c}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/** Used for built-in method references. */

var objectProto$f = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$f;

  return value === proto;
}

var _isPrototype = isPrototype$4;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$3 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$c.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$2;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();

var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var Symbol$6 = root$7.Symbol;

var _Symbol = Symbol$6;

var Symbol$5 = _Symbol;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$4 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$7(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$7;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$5;

var baseGetTag$6 = _baseGetTag,
    isObject$4 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$4(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$6(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
    isMasked = _isMasked,
    isObject$3 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$a).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$6(root$5, 'DataView');

var _DataView = DataView$1;

var getNative$5 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$5(root$4, 'Map');

var _Map = Map$3;

var getNative$4 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$4(root$3, 'Promise');

var _Promise = Promise$2;

var getNative$3 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$3(root$2, 'Set');

var _Set = Set$2;

var getNative$2 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative$2(root$1, 'WeakMap');

var _WeakMap = WeakMap$1;

var DataView = _DataView,
    Map$2 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap = _WeakMap,
    baseGetTag$5 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$6 = '[object Map]',
    objectTag$3 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$6 = '[object Set]',
    weakMapTag$2 = '[object WeakMap]';

var dataViewTag$4 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$5 = baseGetTag$5;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$5(new DataView(new ArrayBuffer(1))) != dataViewTag$4) ||
    (Map$2 && getTag$5(new Map$2) != mapTag$6) ||
    (Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$5(new Set$1) != setTag$6) ||
    (WeakMap && getTag$5(new WeakMap) != weakMapTag$2)) {
  getTag$5 = function(value) {
    var result = baseGetTag$5(value),
        Ctor = result == objectTag$3 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$4;
        case mapCtorString: return mapTag$6;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$6;
        case weakMapCtorString: return weakMapTag$2;
      }
    }
    return result;
  };
}

var _getTag = getTag$5;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$a(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$a;

var baseGetTag$4 = _baseGetTag,
    isObjectLike$9 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$9(value) && baseGetTag$4(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$8 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$8(value) && hasOwnProperty$9.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$3;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$a = Array.isArray;

var isArray_1 = isArray$a;

var isArray$b = /*@__PURE__*/getDefaultExportFromCjs(isArray_1);

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$2(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength$2;

var isFunction = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$4(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike$4;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

isBuffer$4.exports;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$4, isBuffer$4.exports));

var isBufferExports = isBuffer$4.exports;

var baseGetTag$3 = _baseGetTag,
    isLength = isLength_1,
    isObjectLike$7 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$4 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$3] =
typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$4] =
typedArrayTags[setTag$5] = typedArrayTags[stringTag$4] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$7(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag$3(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$5(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$5;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil, _nodeUtil.exports));

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$4 = _baseUnary,
    nodeUtil$3 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$3 && nodeUtil$3.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray ? baseUnary$4(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$3;

var baseKeys$1 = _baseKeys,
    getTag$4 = _getTag,
    isArguments$2 = isArguments_1,
    isArray$9 = isArray_1,
    isArrayLike$3 = isArrayLike_1,
    isBuffer$3 = isBufferExports,
    isPrototype$2 = _isPrototype,
    isTypedArray$2 = isTypedArray_1;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
    setTag$4 = '[object Set]';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$3(value) &&
      (isArray$9(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer$3(value) || isTypedArray$2(value) || isArguments$2(value))) {
    return !value.length;
  }
  var tag = getTag$4(value);
  if (tag == mapTag$4 || tag == setTag$4) {
    return !value.size;
  }
  if (isPrototype$2(value)) {
    return !baseKeys$1(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$8.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

var isEmpty$1 = /*@__PURE__*/getDefaultExportFromCjs(isEmpty_1);

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$3(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$6(value) && baseGetTag$2(value) == symbolTag$3);
}

var isSymbol_1 = isSymbol$3;

var Symbol$3 = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$8 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$8(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$2) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$6(value) {
  return value == null ? '' : baseToString$1(value);
}

var toString_1 = toString$6;

var toString$5 = toString_1;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString$5(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

var escapeRegExp_1 = escapeRegExp;

var escapeRegExp$1 = /*@__PURE__*/getDefaultExportFromCjs(escapeRegExp_1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$f = {
  name: 'SelectorEditor',
  components: {
    PendoMultiselect,
    PendoEditableContent,
    PendoDivider
  },
  props: {
    category: {
      default: '',
      type: String
    },
    value: {
      default: '',
      type: String
    },
    defaultValue: {
      default: '',
      type: String
    },
    editStyle: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      textValue: '',
      dropdownSelection: ''
    };
  },
  computed: {
    dropdownOptions() {
      switch (this.category) {
        case 'id':
          return ['Default', 'Starts With', 'Ends With', 'Contains'];
        case 'className':
          return ['Default', 'Contains'];
        case 'attrib':
          return ['Default', 'Attribute Exists', 'Starts With', 'Ends With', 'Contains'];
        default:
          return ['Default'];
      }
    },
    attributeName() {
      switch (this.category) {
        case 'className':
          return 'class';
        case 'attrib':
          return m(this.defaultValue).name;
        default:
          return this.category;
      }
    },
    origValue() {
      const parsedValue = m(this.defaultValue);
      if (this.category === 'attrib') {
        return parsedValue.value.replaceAll('"', '');
      }
      return parsedValue.name.replaceAll('"', '');
    },
    validationRules() {
      return [{
        message: 'This element does not match the appropriate pattern',
        validator: (rule, value) => this.validateValue(value),
        trigger: ['blur', 'change']
      }];
    },
    prefix() {
      switch (this.dropdownSelection) {
        case 'Starts With':
          return `[${this.attributeName}^="`;
        case 'Ends With':
          return `[${this.attributeName}$="`;
        case 'Contains':
          return `[${this.attributeName}*="`;
        case 'Attribute Exists':
          return `[${this.attributeName}`;
        default:
          return '';
      }
    },
    preview() {
      if (this.dropdownSelection === 'Default') {
        return this.defaultValue;
      }
      return `${this.prefix}${this.textValue}${this.suffix}`;
    },
    suffix() {
      switch (this.dropdownSelection) {
        case 'Default':
          return '';
        case 'Attribute Exists':
          return ']';
        default:
          return '"]';
      }
    },
    showText() {
      return this.dropdownSelection !== 'Default' && this.dropdownSelection !== 'Attribute Exists';
    }
  },
  watch: {
    editStyle: {
      handler(newStyle) {
        if (newStyle !== '') {
          this.emitDropdown(newStyle);
        }
      },
      immediate: true
    },
    value: {
      handler(newValue) {
        if (this.showText && newValue.includes('=')) {
          this.textValue = m(newValue).value.replaceAll('"', '');
        } else {
          this.textValue = this.normalizeTextValue(newValue);
        }
      },
      immediate: true
    }
  },
  methods: {
    emitDropdown(option) {
      this.dropdownSelection = option;
      this.emitValue(this.textValue);
    },
    emitValue(newValue) {
      this.textValue = this.normalizeTextValue(newValue);
      this.$emit('update-value', {
        value: this.preview,
        editStyle: this.dropdownSelection,
        isValid: this.validateValue(newValue)
      });
    },
    normalizeTextValue(value) {
      if (!this.showText) {
        return '';
      }
      if (!isEmpty$1(value)) {
        return value;
      }
      if (!isEmpty$1(this.defaultValue)) {
        return this.origValue;
      }
      return '';
    },
    validateValue(value) {
      const patternMap = {
        'Default': new RegExp('.*'),
        'Attribute Exists': new RegExp('.*'),
        'Starts With': new RegExp(`^${escapeRegExp$1(value)}.*`),
        'Ends With': new RegExp(`.*${escapeRegExp$1(value)}$`),
        'Contains': new RegExp(`.*${escapeRegExp$1(value)}.*`)
      };
      return patternMap[this.dropdownSelection].test(this.origValue);
    }
  }
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "selector-editor"
  }, [_c('p', {
    staticClass: "description-text",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v("\n        Selectors are used to find features on your page. Pendo uses an exact match of the selector by default, but\n        sometimes a more general match is useful.\n    ")]), _vm._v(" "), _c('pendo-multiselect', {
    staticClass: "selector-editor__dropdown",
    attrs: {
      "all-selected-text": "",
      "full-width": "",
      "options": _vm.dropdownOptions,
      "value": _vm.dropdownSelection
    },
    on: {
      "select": _vm.emitDropdown
    }
  }), _vm._v(" "), _vm.showText ? _c('pendo-editable-content', {
    ref: "editableContent",
    staticClass: "selector-editor__input",
    staticStyle: {
      "width": "fit-content"
    },
    attrs: {
      "value": _vm.textValue,
      "validation-rules": _vm.validationRules,
      "empty-text": _vm.textValue,
      "exit-event": "blur"
    },
    on: {
      "input": _vm.emitValue,
      "exitEditMode": _vm.emitValue
    }
  }) : _vm._e(), _vm._v(" "), _c('pendo-divider', {
    attrs: {
      "stroke-dasharray": "2",
      "stroke": "gray"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [_c('p', {
    staticClass: "preview__heading"
  }, [_vm._v("\n            Preview:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "preview__selector",
    attrs: {
      "id": _vm.category
    }
  }, [_vm._v("\n            " + _vm._s(_vm.preview) + "\n        ")])])], 1);
};
var __vue_staticRenderFns__$f = [];

/* style */
const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-7d1de10e_0", {
    source: ".description-text[data-v-7d1de10e]{font-size:12px;font-weight:400}.selector-editor[data-v-7d1de10e]{padding:16px}.selector-editor__input[data-v-7d1de10e]{margin-top:12px}.preview[data-v-7d1de10e]{display:flex;flex-direction:column;gap:6px}.preview__heading[data-v-7d1de10e]{font-size:14px;font-weight:700}.preview__selector[data-v-7d1de10e]{display:flex;padding:4px 8px;border-radius:3px;max-width:fit-content;max-height:20px;align-items:center;font-size:12px;font-weight:600}.preview__selector#id[data-v-7d1de10e]{background-color:#fed6fa}.preview__selector#className[data-v-7d1de10e]{background-color:#dac5f8}.preview__selector#attrib[data-v-7d1de10e]{background-color:#ffd8b1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$f = "data-v-7d1de10e";
/* module identifier */
const __vue_module_identifier__$f = undefined;
/* functional template */
const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var isNil$1 = /*@__PURE__*/getDefaultExportFromCjs(isNil_1);

var baseGetTag$1 = _baseGetTag,
    isArray$7 = isArray_1,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag$3 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray$7(value) && isObjectLike$5(value) && baseGetTag$1(value) == stringTag$3);
}

var isString_1 = isString;

var isString$1 = /*@__PURE__*/getDefaultExportFromCjs(isString_1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const selectorEvent = new Vue();
var script$e = {
  name: 'SelectorButton',
  components: {
    PendoIcon,
    PendoIconButton
  },
  props: {
    id: {
      default: null,
      type: String
    },
    category: {
      default: null,
      type: String
    },
    value: {
      default: null,
      type: String
    },
    defaultValue: {
      default: null,
      type: String
    },
    color: {
      default: null,
      type: String
    },
    closable: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    isNodeActive: {
      type: Boolean,
      default: false
    },
    editStyle: {
      default: null,
      type: String
    },
    configurable: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    isValidColor() {
      const regex = /^#?([0-9a-f]{2}){3,4}$/i;
      return isString$1(this.color) && regex.test(this.color);
    },
    iconType() {
      return this.closable ? 'x' : 'plus';
    },
    isValid() {
      return !isNil$1(this.category) && !isNil$1(this.value);
    },
    isDisabled() {
      return !this.clickable && this.isNodeActive;
    },
    classObject() {
      const classObj = {
        clickable: this.clickable,
        chosen: this.closable,
        available: !this.closable
      };
      classObj[`${this.category}Cat`] = true;
      return classObj;
    },
    tabIndex() {
      return this.clickable ? '0' : '-1';
    },
    styleObject() {
      const styleObj = {};
      if (this.color) {
        styleObj.borderColor = this.color;
        styleObj.backgroundColor = this.closable ? this.color : '#fff';
      }
      return styleObj;
    },
    editable() {
      return (this.category === 'id' || this.category === 'className' || this.category === 'attrib') && this.closable && this.clickable && this.configurable;
    }
  },
  methods: {
    onSelectorClick(event) {
      if (this.clickable) {
        const payload = {
          category: this.category,
          value: this.value,
          closable: this.closable,
          defaultValue: this.defaultValue
        };
        this.$emit('click', payload);
      } else {
        event.preventDefault();
      }
    },
    onSettingsClick(event) {
      const payload = {
        id: this.id,
        category: this.category,
        value: this.value,
        defaultValue: this.defaultValue,
        editStyle: this.editStyle
      };
      selectorEvent.$emit('settings-click', payload);
      event.preventDefault();
    }
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isValid ? _c('button', {
    staticClass: "crb-selector",
    class: _vm.classObject,
    style: _vm.styleObject,
    attrs: {
      "tabindex": _vm.tabIndex,
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.onSelectorClick
    }
  }, [!_vm.closable ? _c('div', {
    staticClass: "crb-selector__plus"
  }, [_c('pendo-icon', {
    attrs: {
      "size": "14",
      "type": "plus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "crb-selector__value"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _vm.editable ? _c('div', {
    staticClass: "edit-icon"
  }, [_c('pendo-icon-button', {
    attrs: {
      "icon-size": "12",
      "icon": "settings"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onSettingsClick.apply(null, arguments);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.closable && _vm.clickable ? _c('div', {
    staticClass: "crb-selector__x"
  }, [_c('pendo-icon', {
    attrs: {
      "size": "14",
      "type": "x"
    }
  })], 1) : _vm._e()]) : _vm._e();
};
var __vue_staticRenderFns__$e = [];

/* style */
const __vue_inject_styles__$e = function (inject) {
  if (!inject) return;
  inject("data-v-c5be513e_0", {
    source: ".crb-selector[data-v-c5be513e]{font-family:Inter;border-radius:3px;border-style:solid;border-width:2px;box-sizing:border-box;display:inline-flex;font-size:12px;font-weight:500;margin:5px 5px;padding:4px 8px;max-width:300px;text-align:left;overflow-wrap:anywhere;cursor:pointer}.crb-selector .pendo-icon-button[data-v-c5be513e]{margin-left:8px;max-height:15px;max-width:15px;min-width:15px;color:#000;background-color:transparent}.crb-selector.containsCat .crb-selector__x[data-v-c5be513e],.crb-selector.nthChildCat .crb-selector__x[data-v-c5be513e],.crb-selector.tagCat .crb-selector__x[data-v-c5be513e]{margin-left:8px}.crb-selector__plus[data-v-c5be513e]{margin-right:4px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$e = "data-v-c5be513e";
/* module identifier */
const __vue_module_identifier__$e = undefined;
/* functional template */
const __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$d = {
  name: 'ConfigureSelector',
  components: {
    SelectorEditor: __vue_component__$f,
    PendoButton
  },
  props: {},
  data() {
    return {
      id: '',
      category: '',
      value: '',
      defaultValue: '',
      editStyle: '',
      tempValue: '',
      tempStyle: '',
      isVisible: false,
      isValid: true
    };
  },
  mounted() {
    if (selectorEvent) {
      selectorEvent.$on('settings-click', event => {
        this.id = event.id;
        this.category = event.category;
        this.editStyle = event.editStyle;
        this.value = event.value;
        this.defaultValue = event.defaultValue;
        this.isVisible = true;
      });
    }
  },
  methods: {
    onCancelClick() {
      this.tempValue = '';
      this.value = '';
      this.tempStyle = '';
      this.editStyle = '';
      this.isVisible = false;
    },
    onApplyClick() {
      selectorEvent.$emit('apply-click', {
        id: this.id,
        value: this.tempValue,
        editStyle: this.tempStyle
      });
      this.tempValue = '';
      this.value = '';
      this.tempStyle = '';
      this.editStyle = '';
      this.isVisible = false;
    },
    onUpdateValue(event) {
      this.tempStyle = event.editStyle;
      this.tempValue = event.value;
      this.isValid = event.isValid;
    }
  }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: {
      displayed: _vm.isVisible,
      hidden: !_vm.isVisible
    }
  }, [_c('selector-editor', {
    attrs: {
      "category": _vm.category,
      "value": _vm.value,
      "default-value": _vm.defaultValue,
      "edit-style": _vm.editStyle
    },
    on: {
      "update-value": _vm.onUpdateValue
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "configure-selector__footer"
  }, [_c('pendo-button', {
    staticClass: "cancel-button",
    attrs: {
      "theme": "app",
      "type": "tertiary",
      "label": "Cancel"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }), _vm._v(" "), _c('pendo-button', {
    staticClass: "apply-button",
    attrs: {
      "disabled": !_vm.isValid,
      "theme": "app",
      "type": "primary",
      "label": "Apply"
    },
    on: {
      "click": _vm.onApplyClick
    }
  })], 1)], 1);
};
var __vue_staticRenderFns__$d = [];

/* style */
const __vue_inject_styles__$d = function (inject) {
  if (!inject) return;
  inject("data-v-4e70443f_0", {
    source: ".configure-selector__footer[data-v-4e70443f]{display:flex;justify-content:flex-end;padding:16px;position:fixed;left:0;bottom:0;border-top:1px solid #eaecf1;width:100%;background-color:#fff;border-radius:0 0 2px 2px}.hidden[data-v-4e70443f]{display:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$d = "data-v-4e70443f";
/* module identifier */
const __vue_module_identifier__$d = undefined;
/* functional template */
const __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$c = {
  name: 'CountableTableExpander',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  props: {
    isExpanded: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    dataUnits: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showTooltip: false
    };
  },
  computed: {
    canExpand() {
      return this.data.length > 2;
    },
    displayData() {
      if (this.canExpand && !this.isExpanded) {
        return this.data.slice(0, 1);
      }
      return this.data;
    },
    expandLabel() {
      return this.isExpanded ? `Collapse ${this.dataUnits}` : `${this.data.length - 1} more ${this.dataUnits}`;
    },
    expandIcon() {
      return this.isExpanded ? 'chevron-up' : 'chevron-down';
    }
  },
  methods: {
    onExpanded() {
      this.$emit('expanded', !this.isExpanded);
    },
    checkOverflow($event) {
      const {
        scrollWidth,
        clientWidth
      } = $event.target;
      this.showTooltip = scrollWidth > clientWidth;
    }
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "countable-table-expander",
    class: {
      'can-expand': _vm.canExpand
    }
  }, [_vm._l(_vm.displayData, function (item, index) {
    return _c('div', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: {
          arrow: true,
          content: _vm.showTooltip ? item : null,
          boundariesElement: 'viewport',
          delay: {
            show: 300,
            hide: 0
          },
          multiline: true
        },
        expression: "{\n            arrow: true,\n            content: showTooltip ? item : null,\n            boundariesElement: 'viewport',\n            delay: { show: 300, hide: 0 },\n            multiline: true\n        }"
      }],
      key: item,
      class: "countable-table-expander__item-" + index,
      on: {
        "mouseover": function ($event) {
          return _vm.checkOverflow($event);
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n    ")]);
  }), _vm._v(" "), _vm.canExpand ? _c('pendo-button', {
    staticClass: "expand",
    attrs: {
      "size": "mini",
      "type": "link",
      "theme": "app",
      "label": _vm.expandLabel,
      "suffix-icon": _vm.expandIcon,
      "icon-size": "12"
    },
    on: {
      "click": _vm.onExpanded
    }
  }) : _vm._e()], 2);
};
var __vue_staticRenderFns__$c = [];

/* style */
const __vue_inject_styles__$c = function (inject) {
  if (!inject) return;
  inject("data-v-48acf6b3_0", {
    source: ".countable-table-rules.can-expand[data-v-48acf6b3]{margin:3px 0}.countable-table-rules__rule[data-v-48acf6b3]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.countable-table-rules .expand[data-v-48acf6b3]{font-style:normal;font-weight:600;font-size:12px;line-height:120%}.countable-table-rules .expand.pendo-button .icon-suffix[data-v-48acf6b3]{padding-left:4px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$c = "data-v-48acf6b3";
/* module identifier */
const __vue_module_identifier__$c = undefined;
/* functional template */
const __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$b = {
  name: 'CountableTableRules',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  props: {
    isExpanded: {
      type: Boolean,
      required: true
    },
    rules: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showTooltip: false
    };
  },
  computed: {
    canExpand() {
      return this.rules.length > 2;
    },
    displayedRules() {
      if (this.canExpand && !this.isExpanded) {
        return this.rules.slice(0, 1);
      }
      return this.rules;
    },
    expandLabel() {
      return this.isExpanded ? 'Collapse rules' : `${this.rules.length - 1} more rules`;
    },
    expandIcon() {
      return this.isExpanded ? 'chevron-up' : 'chevron-down';
    }
  },
  methods: {
    onExpanded() {
      this.$emit('expanded', !this.isExpanded);
    },
    checkOverflow($event) {
      const {
        scrollWidth,
        clientWidth
      } = $event.target;
      this.showTooltip = scrollWidth > clientWidth;
    }
  }
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "countable-table-rules",
    class: {
      'can-expand': _vm.canExpand
    }
  }, [_vm._l(_vm.displayedRules, function (entry, index) {
    return _c('div', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: {
          arrow: true,
          content: _vm.showTooltip ? entry.rule : null,
          boundariesElement: 'viewport',
          delay: {
            show: 300,
            hide: 0
          }
        },
        expression: "{\n            arrow: true,\n            content: showTooltip ? entry.rule : null,\n            boundariesElement: 'viewport',\n            delay: { show: 300, hide: 0 }\n        }"
      }],
      key: index,
      class: "countable-table-rules__rule-" + index,
      on: {
        "mouseover": function ($event) {
          return _vm.checkOverflow($event);
        }
      }
    }, [_vm._v("\n        " + _vm._s(entry.rule) + "\n    ")]);
  }), _vm._v(" "), _vm.canExpand ? _c('pendo-button', {
    staticClass: "expand",
    attrs: {
      "size": "mini",
      "type": "link",
      "theme": "app",
      "label": _vm.expandLabel,
      "suffix-icon": _vm.expandIcon,
      "icon-size": "12"
    },
    on: {
      "click": _vm.onExpanded
    }
  }) : _vm._e()], 2);
};
var __vue_staticRenderFns__$b = [];

/* style */
const __vue_inject_styles__$b = function (inject) {
  if (!inject) return;
  inject("data-v-bf1ce1aa_0", {
    source: ".countable-table-rules.can-expand[data-v-bf1ce1aa]{margin:3px 0}.countable-table-rules__rule[data-v-bf1ce1aa]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.countable-table-rules .expand[data-v-bf1ce1aa]{font-style:normal;font-weight:600;font-size:12px;line-height:120%}.countable-table-rules .expand.pendo-button .icon-suffix[data-v-bf1ce1aa]{padding-left:4px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$b = "data-v-bf1ce1aa";
/* module identifier */
const __vue_module_identifier__$b = undefined;
/* functional template */
const __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$3;

var eq$2 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var getNative$1 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$1(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$1 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;

var _Stack = Stack$2;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$1;

var getNative = _getNative;

var defineProperty$2 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$2;

var defineProperty$1 = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq$1 = eq_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq$1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$4(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$4;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$1;

var baseTimes = _baseTimes,
    isArguments$1 = isArguments_1,
    isArray$6 = isArray_1,
    isBuffer$2 = isBufferExports,
    isIndex = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$6(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$2(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$2 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$3;

var copyObject$3 = _copyObject,
    keys$2 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$3(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$2 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$2(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike$1(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var copyObject$2 = _copyObject,
    keysIn$2 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$2(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

_cloneBuffer.exports;

(function (module, exports) {
	var root = _root;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer; 
} (_cloneBuffer, _cloneBuffer.exports));

var _cloneBufferExports = _cloneBuffer.exports;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var copyObject$1 = _copyObject,
    getSymbols$2 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$1(source, getSymbols$2(source), object);
}

var _copySymbols = copySymbols$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$2 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$2;

var arrayPush$2 = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$2(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var arrayPush$1 = _arrayPush,
    isArray$5 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$5(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$1 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols);
}

var _getAllKeys = getAllKeys$2;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$1 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

/** Used for built-in method references. */

var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$2.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var root = _root;

/** Built-in value references. */
var Uint8Array$2 = root.Uint8Array;

var _Uint8Array = Uint8Array$2;

var Uint8Array$1 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$2 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$2:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor;

    case numberTag$2:
    case stringTag$2:
      return new Ctor(object);

    case regexpTag$3:
      return cloneRegExp(object);

    case setTag$3:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$1 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$3 = _getTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$4(value) && getTag$3(value) == mapTag$2;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$3 = _baseUnary,
    nodeUtil$2 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$3(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$2 = _getTag,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$2 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$3(value) && getTag$2(value) == setTag$2;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$2 = _baseUnary,
    nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary$2(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack$1 = _Stack,
    arrayEach = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBufferExports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys$1 = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag$1 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$4 = isArray_1,
    isBuffer$1 = isBufferExports,
    isMap = isMap_1,
    isObject = isObject_1,
    isSet = isSet_1,
    keys = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] =
cloneableTags[boolTag$1] = cloneableTags[dateTag$1] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag$1] =
cloneableTags[numberTag$1] = cloneableTags[objectTag$1] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$1] =
cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray$4(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag$1 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$1);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys$1)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

var cloneDeep$1 = /*@__PURE__*/getDefaultExportFromCjs(cloneDeep_1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$a = {
  name: 'SelectorNode',
  components: {
    SelectorButton: __vue_component__$e
  },
  props: {
    id: {
      default: '',
      type: String
    },
    selectors: {
      default: () => [],
      type: Array
    },
    active: {
      default: false,
      type: Boolean
    },
    showUnusedNodes: {
      default: false,
      type: Boolean
    },
    siblings: {
      default: () => [],
      type: Array
    },
    shadowNode: {
      default: false,
      type: Boolean
    },
    configurable: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      allSelectors: [],
      siblingSelectors: [],
      unusedSelectors: [],
      chosenSelectorMap: {},
      chosenSiblingMap: {}
    };
  },
  computed: {
    chosenSelectors() {
      return this.allSelectors.filter(selector => this.chosenSelectorMap[selector.id] || false);
    },
    availableSelectors() {
      return this.allSelectors.filter(selector => !this.chosenSelectorMap[selector.id] && selector.valid || false);
    },
    chosenSiblings() {
      return this.siblingSelectors.filter(selector => this.chosenSiblingMap[selector.id] || false);
    },
    availableSiblings() {
      return this.siblingSelectors.filter(selector => !this.chosenSiblingMap[selector.id] && selector.valid || false);
    },
    selectorNodeRule() {
      if (this.chosenSelectors.length === 0) {
        return '';
      }
      const rule = this.chosenSiblings.length ? `${this.chosenSiblings.reduce((rule, selector) => `${rule}${selector.value}`, '')} + ` : '';
      return rule + this.chosenSelectors.reduce((rule, selector) => `${rule}${selector.value}`, '');
    }
  },
  watch: {
    selectors: {
      handler(selectors) {
        this.allSelectors = cloneDeep$1(selectors);
        if (this.shadowNode) {
          this.allSelectors.forEach(selector => {
            if (selector.category === 'tag') {
              Vue.set(this.chosenSelectorMap, selector.id, true);
            }
          });
        }
        if (Object.keys(this.chosenSelectorMap).length === 0) {
          this.allSelectors.forEach(selector => {
            Vue.set(this.chosenSelectorMap, selector.id, selector.chosen);
          });
        }
        this.$emit('update-selector-node', {
          id: this.id,
          nodeRule: this.selectorNodeRule
        });
      },
      immediate: true
    },
    siblings: {
      handler(siblings) {
        this.siblingSelectors = cloneDeep$1(siblings);
        if (Object.keys(this.chosenSiblingMap).length === 0) {
          this.siblingSelectors.forEach(selector => {
            Vue.set(this.chosenSiblingMap, selector.id, selector.chosen);
          });
        }
        this.$emit('update-selector-node', {
          id: this.id,
          nodeRule: this.selectorNodeRule
        });
      },
      immediate: true
    }
  },
  created() {
    if (this.chosenSelectors.length === 0) {
      this.siblingSelectors.forEach(sibling => {
        sibling.chosen = false;
        sibling.clickable = false;
      });
    }
  },
  methods: {
    onSelectorClick(event) {
      const selectorIndex = this.allSelectors.findIndex(s => s.category === event.category && s.defaultValue === event.defaultValue);
      const selector = this.allSelectors[selectorIndex];
      Vue.set(this.chosenSelectorMap, selector.id, selector.valid && !this.chosenSelectorMap[selector.id]);
      this.$nextTick(() => {
        const idRef = this.$refs[selector.id];
        if (!isEmpty$1(idRef)) {
          idRef[0].$el.focus();
        }
      });
      if (this.chosenSelectors.length === 0) {
        this.siblingSelectors.forEach(sibling => {
          Vue.set(this.chosenSiblingMap, sibling.id, false);
          sibling.clickable = false;
        });
      } else {
        this.siblingSelectors.forEach(sibling => {
          sibling.clickable = true;
        });
      }
      this.$emit('update-selector-node', {
        id: this.id,
        nodeRule: this.selectorNodeRule
      });
    },
    onSiblingClick(event) {
      const clickedSelectors = this.siblingSelectors;
      const selectorIndex = this.siblingSelectors.findIndex(s => s.category === event.category && s.defaultValue === event.defaultValue);
      const selector = clickedSelectors[selectorIndex];
      Vue.set(this.chosenSiblingMap, selector.id, selector.valid && !this.chosenSiblingMap[selector.id]);
      this.$nextTick(() => {
        const idRef = this.$refs[selector.id];
        if (idRef) {
          idRef[0].$el.focus();
        }
      });
      this.$emit('update-selector-node', {
        id: this.id,
        nodeRule: this.selectorNodeRule
      });
    }
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "crb-selector-node"
  }, [!_vm.active ? _c('div', {
    staticClass: "crb-selector-node__inactive",
    attrs: {
      "aria-expanded": "false",
      "tabindex": "" + (_vm.chosenSelectors.length ? '0' : '-1')
    }
  }, [_vm.chosenSelectors.length === 0 && _vm.showUnusedNodes ? _c('div', {
    staticClass: "crb-selector-node__empty"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.chosenSelectors.length === 0 ? '' : 'chosen-selectors'
  }, [_vm._l(_vm.chosenSiblings, function (sibling) {
    return _c('selector-button', {
      key: sibling.id,
      class: {
        invalid: !sibling.valid
      },
      attrs: {
        "id": sibling.id,
        "category": sibling.category,
        "default-value": sibling.defaultValue,
        "value": sibling.value,
        "clickable": false,
        "closable": true,
        "configurable": _vm.configurable,
        "is-node-active": _vm.active,
        "edit-style": sibling.editStyle
      }
    });
  }), _vm._v(" "), _vm.chosenSiblings.length ? _c('p', {
    attrs: {
      "id": "plus"
    }
  }, [_vm._v("\n                +\n            ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.chosenSelectors, function (selector) {
    return _c('selector-button', {
      key: selector.id,
      class: {
        invalid: !selector.valid
      },
      attrs: {
        "id": selector.id,
        "value": selector.value,
        "category": selector.category,
        "default-value": selector.defaultValue,
        "clickable": false,
        "configurable": _vm.configurable,
        "is-node-active": _vm.active,
        "edit-style": selector.editStyle,
        "closable": true
      }
    });
  })], 2)]) : _vm.chosenSelectors.length === 0 && _vm.availableSelectors.length === 0 ? _c('div', {
    staticClass: "crb-selector-node__unavailable"
  }, [_vm._v("\n        All possible selectors have been marked as unavailable. Please update your settings.\n    ")]) : _c('div', {
    staticClass: "crb-selector-node__active",
    attrs: {
      "tabindex": "0",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "crb-selector-node__selected"
  }, [_vm.chosenSelectors.length === 0 && _vm.chosenSiblings.length === 0 ? _c('div', {
    staticClass: "empty-node"
  }) : _c('div', {
    staticClass: "chosen-selectors"
  }, [_vm._l(_vm.chosenSiblings, function (sibling) {
    return _c('selector-button', {
      key: sibling.id,
      ref: sibling.id,
      refInFor: true,
      class: {
        invalid: !sibling.valid
      },
      attrs: {
        "id": sibling.id,
        "category": sibling.category,
        "value": sibling.value,
        "default-value": sibling.defaultValue,
        "clickable": sibling.clickable,
        "closable": true,
        "configurable": _vm.configurable,
        "edit-style": sibling.editStyle,
        "is-node-active": _vm.active
      },
      on: {
        "click": _vm.onSiblingClick
      }
    });
  }), _vm._v(" "), _vm.chosenSiblings.length ? _c('p', {
    attrs: {
      "id": "plus"
    }
  }, [_vm._v("\n                    +\n                ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.chosenSelectors, function (selector) {
    return _c('selector-button', {
      key: selector.id,
      ref: selector.id,
      refInFor: true,
      class: {
        invalid: !selector.valid
      },
      attrs: {
        "id": selector.id,
        "category": selector.category,
        "value": selector.value,
        "default-value": selector.defaultValue,
        "clickable": !(_vm.shadowNode && selector.category === 'tag'),
        "closable": !(_vm.shadowNode && selector.category === 'tag'),
        "configurable": _vm.configurable,
        "is-node-active": _vm.active,
        "edit-style": selector.editStyle
      },
      on: {
        "click": _vm.onSelectorClick
      }
    });
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "crb-selector-node__available"
  }, [_vm.availableSelectors.length === 0 && _vm.availableSiblings.length === 0 ? _c('div', {
    staticClass: "empty-node"
  }) : _c('div', {
    staticClass: "available-selectors"
  }, [_c('p', {
    attrs: {
      "id": "choose"
    }
  }, [_vm._v("\n                    Choose from below to add to rule:\n                ")]), _vm._v(" "), _vm.availableSiblings.length ? _c('p', {
    staticClass: "selector-label"
  }, [_vm._v("\n                    Sibling Selectors\n                ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.availableSiblings, function (sibling) {
    return _c('selector-button', {
      key: sibling.id,
      ref: sibling.id,
      refInFor: true,
      class: {
        invalid: !sibling.valid
      },
      attrs: {
        "id": sibling.id,
        "category": sibling.category,
        "value": sibling.value,
        "default-value": sibling.defaultValue,
        "clickable": sibling.clickable,
        "closable": false,
        "configurable": _vm.configurable,
        "is-node-active": _vm.active,
        "edit-style": sibling.editStyle
      },
      on: {
        "click": _vm.onSiblingClick
      }
    });
  }), _vm._v(" "), _vm.availableSelectors.length ? _c('p', {
    staticClass: "selector-label"
  }, [_vm._v("\n                    Selectors\n                ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.availableSelectors, function (selector) {
    return _c('selector-button', {
      key: selector.id,
      ref: selector.id,
      refInFor: true,
      class: {
        invalid: !selector.valid
      },
      attrs: {
        "id": selector.id,
        "category": selector.category,
        "value": selector.value,
        "default-value": selector.defaultValue,
        "clickable": true,
        "closable": false,
        "configurable": _vm.configurable,
        "is-node-active": _vm.active,
        "edit-style": selector.editStyle
      },
      on: {
        "click": _vm.onSelectorClick
      }
    });
  })], 2)])])]);
};
var __vue_staticRenderFns__$a = [];

/* style */
const __vue_inject_styles__$a = function (inject) {
  if (!inject) return;
  inject("data-v-269cd705_0", {
    source: ".crb-selector-node[data-v-269cd705]{font-family:Inter;font-weight:300;font-size:13px;background:#eaecf1;border-radius:5px;cursor:pointer}.crb-selector-node__active[data-v-269cd705]{background:#dadce5;border:2px solid #babcc5!important;border-radius:5px;cursor:default}.crb-selector-node__active .crb-selector[data-v-269cd705]:not(.clickable){background-color:#f8f8f9!important;border-color:#babcc5!important;cursor:default}.crb-selector-node__empty[data-v-269cd705]{height:37px}.crb-selector-node .selector-label[data-v-269cd705]{font-weight:600;margin:0 5px;margin-top:10px}.crb-selector-node p[data-v-269cd705]{margin-left:5px}.crb-selector-node p#choose[data-v-269cd705]{padding-top:20px;margin:0 5px}.crb-selector-node .chosen-selectors[data-v-269cd705]{display:flex;align-items:center;flex-wrap:wrap;justify-content:flex-start}.crb-selector-node .chosen-selectors #plus[data-v-269cd705]{font-size:25px;margin:0 5px;color:#6a6c75}.crb-selector-node .crb-selector.tagCat.chosen[data-v-269cd705]{background-color:#c7eddb;border-color:#c7eddb}.crb-selector-node .crb-selector.tagCat.chosen.clickable[data-v-269cd705]:hover{background-color:#8dddb6;border-color:#8dddb6}.crb-selector-node .crb-selector.tagCat.available[data-v-269cd705]{background-color:#fff;border:2px solid #00aa62}.crb-selector-node .crb-selector.tagCat.available[data-v-269cd705]:hover{background-color:#e3f7ed;border:2px solid #00aa62}.crb-selector-node .crb-selector.idCat.chosen[data-v-269cd705]{background-color:#fed6fa;border-color:#fed6fa}.crb-selector-node .crb-selector.idCat.chosen.clickable[data-v-269cd705]:hover{background-color:#fbbef7;border-color:#fbbef7}.crb-selector-node .crb-selector.idCat.available[data-v-269cd705]{background-color:#fff;border:2px solid #d035c1}.crb-selector-node .crb-selector.idCat.available[data-v-269cd705]:hover{background-color:#fff0fe;border:2px solid #d035c1}.crb-selector-node .crb-selector.classNameCat.chosen[data-v-269cd705]{background-color:#dac5f8;border-color:#dac5f8}.crb-selector-node .crb-selector.classNameCat.chosen.clickable[data-v-269cd705]:hover{background-color:#c29ef5;border-color:#c29ef5}.crb-selector-node .crb-selector.classNameCat.available[data-v-269cd705]{background-color:#fff;border:2px solid #7423e2}.crb-selector-node .crb-selector.classNameCat.available[data-v-269cd705]:hover{background-color:#f1e7fc;border:2px solid #7423e2}.crb-selector-node .crb-selector.attribCat.chosen[data-v-269cd705]{background-color:#ffd8b1;border-color:#ffd8b1}.crb-selector-node .crb-selector.attribCat.chosen.clickable[data-v-269cd705]:hover{background-color:#ffb571;border-color:#ffb571}.crb-selector-node .crb-selector.attribCat.available[data-v-269cd705]{background-color:#fff;border:2px solid #f05b00}.crb-selector-node .crb-selector.attribCat.available[data-v-269cd705]:hover{background-color:#fff8f1;border:2px solid #f05b00}.crb-selector-node .crb-selector.containsCat.chosen[data-v-269cd705]{background-color:#bdddff;border-color:#bdddff}.crb-selector-node .crb-selector.containsCat.chosen.clickable[data-v-269cd705]:hover{background-color:#88c2ff;border-color:#88c2ff}.crb-selector-node .crb-selector.containsCat.available[data-v-269cd705]{background-color:#fff;border:2px solid #028cc2}.crb-selector-node .crb-selector.containsCat.available[data-v-269cd705]:hover{background-color:#e2f0ff;border:2px solid #028cc2}.crb-selector-node .crb-selector.nthChildCat.chosen[data-v-269cd705]{background-color:#ffc2c7;border-color:#ffc2c7}.crb-selector-node .crb-selector.nthChildCat.chosen.clickable[data-v-269cd705]:hover{background-color:#ffaab2;border-color:#ffaab2}.crb-selector-node .crb-selector.nthChildCat.available[data-v-269cd705]{background-color:#fff;border:2px solid #ff6582}.crb-selector-node .crb-selector.nthChildCat.available[data-v-269cd705]:hover{background-color:#ffebeb;border:2px solid #ff6582}.crb-selector-node .crb-selector.invalid.chosen[data-v-269cd705]{background-color:#e83b3b;border-color:#e83b3b}.crb-selector-node .crb-selector.invalid.chosen.clickable[data-v-269cd705]:hover{background-color:#f8b0b0;border-color:#f8b0b0}.crb-selector-node .crb-selector.invalid.available[data-v-269cd705]{background-color:#fff;border:2px solid #a50000}.crb-selector-node .crb-selector.invalid.available[data-v-269cd705]:hover{background-color:#f8b0b0;border:2px solid #a50000}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$a = "data-v-269cd705";
/* module identifier */
const __vue_module_identifier__$a = undefined;
/* functional template */
const __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$9 = {
  name: 'CustomRuleSelect',
  components: {
    SelectorNode: __vue_component__$a
  },
  props: {
    selectorNodes: {
      default: () => [],
      type: Array
    },
    showUnusedNodes: {
      default: false,
      type: Boolean
    },
    configurable: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      selectorNodeRules: {},
      selectorNodePrevIds: {},
      selectorNodeShadows: {},
      activeNodeIdx: 0
    };
  },
  computed: {
    ruleEntries() {
      return Object.entries(this.selectorNodeRules);
    },
    numUnusedSelectorNodes() {
      return this.ruleEntries.filter(node => node[1] === '').length;
    },
    currentRule() {
      let currentRule = '';
      for (const [id, value] of this.ruleEntries) {
        if (value !== '') {
          const prevNodeId = this.selectorNodePrevIds[id];
          const ruleOfPrevNode = this.selectorNodeRules[prevNodeId] === undefined ? '' : this.selectorNodeRules[prevNodeId];
          if (ruleOfPrevNode !== '') {
            currentRule = `${currentRule} > ${value}`;
          } else {
            currentRule = `${currentRule} ${value}`;
          }
          if (this.selectorNodeShadows[id]) {
            currentRule = `${currentRule}::shadow`;
          }
        }
      }
      return currentRule.trim();
    }
  },
  watch: {
    selectorNodes: {
      handler(selectorNodes) {
        this.selectoreNodePrevIds = {};
        let prevId = '';
        this.selectorNodeRules = {};
        for (const node of selectorNodes) {
          this.selectorNodePrevIds[node.id] = prevId;
          this.selectorNodeShadows[node.id] = node.shadow;
          prevId = node.id;
        }
      },
      immediate: true
    }
  },
  created() {
    this.activeNodeIdx = this.selectorNodes.length - 1;
  },
  methods: {
    decrementActiveNode() {
      let idx = this.activeNodeIdx - 1;
      while (idx >= 0 && this.ruleEntries[idx][1] === '') {
        idx--;
      }
      if (idx >= 0) {
        this.updateActiveNode(idx);
      }
    },
    incrementActiveNode() {
      let idx = this.activeNodeIdx + 1;
      while (idx < this.ruleEntries.length && this.ruleEntries[idx][1] === '') {
        idx++;
      }
      if (idx < this.ruleEntries.length) {
        this.updateActiveNode(idx);
      }
    },
    updateActiveNode(idx) {
      this.activeNodeIdx = idx;
      this.$nextTick(() => {
        this.$refs.nodes[idx].$el.focus();
      });
    },
    selectorNodeChange(selectorNodeRule) {
      Vue.set(this.selectorNodeRules, selectorNodeRule.id, selectorNodeRule.nodeRule);
      if (this.ruleEntries.length === this.selectorNodes.length) {
        this.$emit('changed-rule', {
          currentRule: this.currentRule,
          numUnused: this.numUnusedSelectorNodes
        });
      }
    }
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._l(_vm.selectorNodes, function (selectorNode, nodeIdx) {
    return _c('selector-node', {
      key: selectorNode.id,
      ref: "nodes",
      refInFor: true,
      staticClass: "crb-custom-rule-select__row",
      attrs: {
        "id": selectorNode.id,
        "configurable": _vm.configurable,
        "selectors": selectorNode.selectors,
        "siblings": selectorNode.siblings,
        "active": nodeIdx === _vm.activeNodeIdx,
        "show-unused-nodes": _vm.showUnusedNodes,
        "shadow-node": selectorNode.shadow
      },
      on: {
        "update-selector-node": _vm.selectorNodeChange
      },
      nativeOn: {
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
            return null;
          }
          return _vm.decrementActiveNode.apply(null, arguments);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
            return null;
          }
          return _vm.incrementActiveNode.apply(null, arguments);
        }],
        "click": function ($event) {
          return _vm.updateActiveNode(nodeIdx);
        }
      }
    });
  }), 1);
};
var __vue_staticRenderFns__$9 = [];

/* style */
const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-0ad3d07a_0", {
    source: ".crb-custom-rule-select__row[data-v-0ad3d07a]{margin:10px}.crb-custom-rule-select .selector-node[data-v-0ad3d07a]:hover{margin:9px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$9 = "data-v-0ad3d07a";
/* module identifier */
const __vue_module_identifier__$9 = undefined;
/* functional template */
const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

var baseGetTag = _baseGetTag,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var regexpTag$1 = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp$1(value) {
  return isObjectLike$2(value) && baseGetTag(value) == regexpTag$1;
}

var _baseIsRegExp = baseIsRegExp$1;

var baseIsRegExp = _baseIsRegExp,
    baseUnary$1 = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary$1(nodeIsRegExp) : baseIsRegExp;

var isRegExp_1 = isRegExp;

var isRegExp$1 = /*@__PURE__*/getDefaultExportFromCjs(isRegExp_1);

const _PENDO_SELECTION_HIGHLIGHT_CLASS = 'pendo-selection-HL';
const _PENDO_SELECTION_CLASS = 'pendo-selection';
const _PENDO_TAGGED_CLASS = 'pendo-tagged-HL';
const _PENDO_OVERLAY_CLASS = 'pendo-overlay';
const _PENDO_TOOLTIP_CLASS = 'pendo-tooltip';
const _PENDO_OVERLAY_TARGET_CLASS = 'pendo-overlay-target';
const _PENDO_IGNORE_CLASS = 'pendo-ignore';
const CLASS_EXCLUDELIST = [_PENDO_SELECTION_HIGHLIGHT_CLASS, `orig-${_PENDO_SELECTION_HIGHLIGHT_CLASS}`, _PENDO_SELECTION_CLASS, _PENDO_TAGGED_CLASS, _PENDO_OVERLAY_CLASS, _PENDO_TOOLTIP_CLASS, _PENDO_OVERLAY_TARGET_CLASS, _PENDO_IGNORE_CLASS,
// Exclude all the classes generated by Tether
/^pendo-tether-/,
// Ignore meaningless classes based on framework...
// Angular
'ng-isolate-scope', 'ng-scope', 'ng-hide', 'ng-show', 'ng-binding',
// Bootstrap
'pull-left', 'pull-right',
// https://pendo-io.atlassian.net/browse/APP-11337
/^jss\d+/,
// Sam's club uses this as part of their "riversand" platform
/^rs[a-zA-Z0-9]{16}$/,
// class names can't start with numbers (this is based on the w3c spec)
// Sizzle doesn't follow the spec, but the backend does, so we can't allow 'em
/^\d/];
const ID_EXCLUDELIST = [/ext-gen\d+/, /ext-comp-\d+/, /x-auto-\d+/, /gwt-uid-\d+/, /yui-gen\d+/, /yui_.*/, /^rs[a-zA-Z0-9]{16}$/, /ember\d+/];
class TaggingExclusions {
  constructor() {
    this.classTagExclusions = [];
    this.idTagExclusions = [];
  }
  handleWildcards(element) {
    switch (true) {
      case isString$1(element) && element.startsWith('*') && element.endsWith('*'):
        return new RegExp(element.slice(1, -1));
      case isString$1(element) && element.startsWith('*'):
        return new RegExp(`${element.slice(1)}$`);
      case isString$1(element) && element.endsWith('*'):
        return new RegExp(`^${element.slice(0, -1)}`);
      default:
        return element;
    }
  }
  getExclusions(globalExclusions, subExclusions) {
    return globalExclusions.map(element => {
      if (isString$1(element)) {
        return new RegExp(`^${element}$`, 'i');
      }
      return element;
    }).concat(subExclusions);
  }
  setExclusions(exclusions) {
    if (!isArray$b(exclusions)) {
      return [];
    }
    return exclusions.map(element => this.handleWildcards(element)).filter(element => element !== undefined);
  }
  isExcluded(excludeList, selector) {
    return excludeList.find(ignoredSelector => {
      return isRegExp$1(ignoredSelector) && ignoredSelector.test(selector) || isString$1(ignoredSelector) && ignoredSelector === selector;
    });
  }
  get classExclusions() {
    return this.getExclusions(CLASS_EXCLUDELIST, this.classTagExclusions);
  }
  set classExclusions(classExclusions) {
    this.classTagExclusions = this.setExclusions(classExclusions);
  }
  isExcludedClass(cls) {
    return this.isExcluded(this.classExclusions, cls);
  }
  get idExclusions() {
    return this.getExclusions(ID_EXCLUDELIST, this.idTagExclusions);
  }
  set idExclusions(idExclusions) {
    this.idTagExclusions = this.setExclusions(idExclusions);
  }
  isExcludedId(id) {
    return this.isExcluded(this.idExclusions, id);
  }
}

function sanitizeContainsText(text) {
  let singleQuoteIndex;
  let doubleQuoteIndex;
  let quote;
  text = text.trim();
  if (text && text.length > 0 && text.length < 129 && !/\u00a0/.test(text)) {
    singleQuoteIndex = text.indexOf("'");
    doubleQuoteIndex = text.indexOf('"');
    // Choosing whether to use `'` or `"` when wrapping :contains input.
    // `'` if it's not found in text.
    // OR if a `"` is found before an instance of `'`
    if (singleQuoteIndex === -1 || doubleQuoteIndex !== -1 && doubleQuoteIndex < singleQuoteIndex) {
      quote = "'";
      // Using `"` if `'` is used in input before `"`
    } else {
      quote = '"';
    }

    // text set to first substring of text that doesn't include
    // \f, \n, \r, and the type of quotation mark used to wrap :contains.
    text = new RegExp(`^[^\\f\\n\\r${quote}]+`).exec(text);
    return text ? `:contains(${quote}${text[0]}${quote})` : '';
  }
  return '';
}

const taggingExclusions = new TaggingExclusions();
function parseSiblingNode(node, idPrefix = '') {
  const siblingArray = [];
  const siblingAttrs = Object.keys(node.attrs).filter(attr => /^_pendo_sibling_/.test(attr));
  if (siblingAttrs.length === 0) {
    return siblingArray;
  }
  if (node.attrs._pendo_sibling_tag) {
    siblingArray.push({
      id: `${idPrefix}ss${siblingArray.length}`,
      category: 'tag',
      value: node.attrs._pendo_sibling_tag.toLowerCase(),
      defaultValue: node.attrs._pendo_sibling_tag.toLowerCase(),
      chosen: false,
      valid: true,
      editStyle: 'Default'
    });
  }
  if (node.attrs._pendo_sibling_id) {
    if (node.attrs._pendo_sibling_id !== '' && !taggingExclusions.isExcludedId(node.attrs._pendo_sibling_id)) {
      siblingArray.push({
        id: `${idPrefix}ss${siblingArray.length}`,
        category: 'id',
        value: `#${node.attrs._pendo_sibling_id}`,
        defaultValue: `#${node.attrs._pendo_sibling_id}`,
        chosen: false,
        valid: true,
        editStyle: 'Default'
      });
    }
  }
  if (node.attrs._pendo_sibling_class) {
    for (const cls of node.attrs._pendo_sibling_class.split(' ')) {
      if (cls.trim() !== '' && !taggingExclusions.isExcludedClass(cls.trim())) {
        siblingArray.push({
          id: `${idPrefix}ss${siblingArray.length}`,
          category: 'className',
          value: `.${cls}`,
          defaultValue: `.${cls}`,
          chosen: false,
          valid: true,
          editStyle: 'Default'
        });
      }
    }
  }
  const siblingAttrEntries = Object.entries(node.attrs).filter(([key]) => /^_pendo_sibling_attr/.test(key));
  for (const [key, value] of siblingAttrEntries) {
    siblingArray.push({
      id: `${idPrefix}ss${siblingArray.length}`,
      category: 'attrib',
      value: `[${key.slice(21)}="${value}"]`,
      defaultValue: `[${key.slice(21)}="${value}"]`,
      chosen: false,
      valid: true,
      editStyle: 'Default'
    });
  }
  if (node.attrs._pendo_sibling_pendo_text) {
    siblingArray.push({
      id: `${idPrefix}ss${siblingArray.length}`,
      category: 'contains',
      value: `:contains("${node.attrs._pendo_sibling_pendo_text.trim()}")`,
      defaultValue: `:contains("${node.attrs._pendo_sibling_pendo_text.trim()}")`,
      chosen: false,
      valid: true,
      editStyle: 'Default'
    });
  }
  return siblingArray;
}
function parseContextNode(node, idPrefix = '') {
  const selectorArray = [];
  selectorArray.push({
    id: `${idPrefix}s${selectorArray.length}`,
    category: 'tag',
    value: node.tag.toLowerCase(),
    defaultValue: node.tag.toLowerCase(),
    chosen: false,
    valid: true,
    editStyle: 'Default'
  });
  if (node.id !== '' && !taggingExclusions.isExcludedId(node.id)) {
    selectorArray.push({
      id: `${idPrefix}s${selectorArray.length}`,
      category: 'id',
      value: `#${node.id}`,
      defaultValue: `#${node.id}`,
      chosen: false,
      valid: true,
      editStyle: 'Default'
    });
  }
  for (const cls of node.cls.trim().split(' ')) {
    if (cls !== '' && cls !== ' ' && !taggingExclusions.isExcludedClass(cls)) {
      selectorArray.push({
        id: `${idPrefix}s${selectorArray.length}`,
        category: 'className',
        value: `.${cls}`,
        defaultValue: `.${cls}`,
        chosen: false,
        valid: true,
        editStyle: 'Default'
      });
    }
  }
  if (Object.keys(node.attrs).length > 0) {
    for (const [key, value] of Object.entries(node.attrs)) {
      if (!/^_pendo_sibling_/.test(key)) {
        selectorArray.push({
          id: `${idPrefix}s${selectorArray.length}`,
          category: 'attrib',
          value: `[${key}="${value}"]`,
          defaultValue: `[${key}="${value}"]`,
          chosen: false,
          valid: true,
          editStyle: 'Default'
        });
      }
    }
  }
  if (node.txt && sanitizeContainsText(node.txt).length > 0) {
    selectorArray.push({
      id: `${idPrefix}s${selectorArray.length}`,
      category: 'contains',
      value: sanitizeContainsText(node.txt),
      defaultValue: sanitizeContainsText(node.txt),
      chosen: false,
      valid: true,
      editStyle: 'Default'
    });
  }
  selectorArray.push({
    id: `${idPrefix}s${selectorArray.length}`,
    category: 'nthChild',
    value: `:nth-child(${node.childIndex + 1})`,
    defaultValue: `:nth-child(${node.childIndex + 1})`,
    chosen: false,
    valid: true,
    editStyle: 'Default'
  });
  return selectorArray;
}
function parseContext(context, depth = 0, prefix = '') {
  if (!context.parentElem) {
    return [{
      id: `${prefix}n${depth}`,
      selectors: parseContextNode(context, `${prefix}n${depth}`),
      siblings: parseSiblingNode(context, `${prefix}n${depth}`),
      shadow: false
    }];
  }
  const nodeArray = parseContext(context.parentElem, depth + 1, prefix);
  nodeArray.push({
    id: `${prefix}n${depth}`,
    selectors: parseContextNode(context, `${prefix}n${depth}`),
    siblings: parseSiblingNode(context, `${prefix}n${depth}`),
    shadow: false
  });
  return nodeArray;
}
function generateAttributeRuleNode(node) {
  const attribNode = {
    value: node.content
  };
  let attribPrefix;
  let attribSuffix;
  switch (node.name) {
    case 'id':
      attribNode.category = 'id';
      attribPrefix = '^#';
      attribSuffix = '$';
      break;
    case 'class':
      attribNode.category = 'className';
      attribPrefix = '^\\.';
      attribSuffix = '$';
      break;
    default:
      attribNode.category = 'attrib';
      attribPrefix = `^\\[${node.name}=['\\"]`;
      attribSuffix = '[\'\\"]\\]$';
      break;
  }
  if (!node.operator) {
    attribNode.regex = new RegExp(`${attribPrefix}.*`);
    attribNode.editStyle = 'Attribute Exists';
  } else {
    let rawValue = node.value.replace(/^(['\\"])(.*)(['\\"])$/, '$2');
    switch (node.operator) {
      case '^=':
        rawValue = `${rawValue}.*`;
        attribNode.editStyle = 'Starts With';
        break;
      case '$=':
        rawValue = `.*${rawValue}`;
        attribNode.editStyle = 'Ends With';
        break;
      case '*=':
        rawValue = `.*${rawValue}.*`;
        attribNode.editStyle = 'Contains';
        break;
      default:
        attribNode.editStyle = 'Default';
        break;
    }
    attribNode.regex = new RegExp(`${attribPrefix}${rawValue}${attribSuffix}`);
  }
  return attribNode;
}
function parseRuleNodes(ruleNodes) {
  let parsedNode = {
    shadow: false,
    selectors: [],
    siblings: []
  };
  let parsedNodeArr = [];
  let nodeType = 'selectors';
  const subNodeArr = [];
  ruleNodes.reverse().forEach(node => {
    switch (node.type) {
      case 'type':
        parsedNode[nodeType].push({
          category: 'tag',
          value: node.content
        });
        break;
      case 'id':
        parsedNode[nodeType].push({
          category: 'id',
          value: node.content
        });
        break;
      case 'class':
        parsedNode[nodeType].push({
          category: 'className',
          value: node.content
        });
        break;
      case 'attribute':
        parsedNode[nodeType].push(generateAttributeRuleNode(node));
        break;
      case 'pseudo-class':
        if (node.name === 'contains' || node.name === 'nth-child') {
          const camelCasedNodeName = node.name.replace(/-./g, x => x[1].toUpperCase());
          parsedNode[nodeType].push({
            category: camelCasedNodeName,
            value: node.content
          });
        }
        break;
      case 'pseudo-element':
        if (node.name === 'shadow') {
          parsedNode.shadow = true;
        }
        break;
      case 'combinator':
        if (node.content === '+') {
          nodeType = 'siblings';
        } else {
          nodeType = 'selectors';
          parsedNodeArr.unshift(parsedNode);
          parsedNode = {
            selectors: [],
            siblings: []
          };
          if (node.content === ' ') {
            subNodeArr.push(parsedNodeArr.reduce((acc, cur) => {
              return acc === null ? {
                ...cur,
                ruleDepth: 1
              } : {
                ...cur,
                ruleDepth: acc.ruleDepth + 1,
                parent: acc
              };
            }, null));
            parsedNodeArr = [];
          }
        }
        break;
    }
  });
  parsedNodeArr.unshift(parsedNode);
  subNodeArr.push(parsedNodeArr.reduce((acc, cur) => {
    return acc === null ? {
      ...cur,
      ruleDepth: 1
    } : {
      ...cur,
      ruleDepth: acc.ruleDepth + 1,
      parent: acc
    };
  }, null));
  return subNodeArr;
}
function parseRule(rule) {
  const ruleNodes = u(rule);
  return parseRuleNodes(ruleNodes);
}
function selectorCompareFn(ruleNode, contextNode, mutateContext = false) {
  if (ruleNode.regex) {
    const isMatch = ruleNode.regex.test(contextNode.defaultValue);
    if (mutateContext && isMatch) {
      contextNode.value = ruleNode.value;
      contextNode.editStyle = ruleNode.editStyle;
    }
    return isMatch;
  }
  return contextNode.category === ruleNode.category && contextNode.value === ruleNode.value;
}
function nodeCompareFn(ruleNode, type, depth, contextNodes, outerFn, innerFn, mutateRule) {
  return ruleNode[type][outerFn](ns => contextNodes[depth][type][innerFn](es => selectorCompareFn(ns, es, mutateRule)));
}
function matchRuleNodeAtDepth(ruleNode, type, depth, contextNodes) {
  return nodeCompareFn(ruleNode, type, depth, contextNodes, 'every', 'some', false);
}
function matchRuleNodeToContext(ruleNode, depth, contextNodes) {
  return matchRuleNodeAtDepth(ruleNode, 'selectors', depth, contextNodes) && matchRuleNodeAtDepth(ruleNode, 'siblings', depth, contextNodes) && (!ruleNode.parent || matchRuleNodeToContext(ruleNode.parent, depth - 1, contextNodes));
}
function findMatchedIndices(ruleNode, type, depth, contextNodes) {
  return nodeCompareFn(ruleNode, type, depth, contextNodes, 'map', 'findIndex', true);
}
function generateSelectorNodeData(context, rule, prefix = '') {
  const parsedContextNodes = parseContext(context, 0, prefix);
  const parsedRuleNodes = parseRule(rule);
  let contextDepth = parsedContextNodes.length - 1;
  let ruleNode;
  const matchedSelectors = [];
  const matchedSiblings = [];
  let failedMatch = false;
  while (contextDepth >= 0 && parsedRuleNodes.length > 0) {
    ruleNode = parsedRuleNodes.shift();
    if (contextDepth < ruleNode.ruleDepth - 1) {
      failedMatch = true;
      break;
    }
    while (!matchRuleNodeToContext(ruleNode, contextDepth, parsedContextNodes)) {
      contextDepth--;
      if (contextDepth < ruleNode.ruleDepth - 1) {
        failedMatch = true;
        break;
      }
    }
    while (ruleNode.parent) {
      parsedContextNodes[contextDepth].shadow = ruleNode.shadow;
      matchedSelectors[contextDepth] = findMatchedIndices(ruleNode, 'selectors', contextDepth, parsedContextNodes);
      matchedSiblings[contextDepth] = findMatchedIndices(ruleNode, 'siblings', contextDepth, parsedContextNodes);
      ruleNode = ruleNode.parent;
      contextDepth--;
    }
    parsedContextNodes[contextDepth].shadow = ruleNode.shadow;
    matchedSelectors[contextDepth] = findMatchedIndices(ruleNode, 'selectors', contextDepth, parsedContextNodes);
    matchedSiblings[contextDepth] = findMatchedIndices(ruleNode, 'siblings', contextDepth, parsedContextNodes);
    contextDepth--;
  }
  if (!failedMatch) {
    matchedSelectors.forEach((indices, depth) => {
      if (indices !== null) {
        indices.forEach(selectorIdx => {
          parsedContextNodes[depth].selectors[selectorIdx].chosen = true;
        });
      }
    });
    matchedSiblings.forEach((indices, depth) => {
      if (indices !== null) {
        indices.forEach(selectorIdx => {
          parsedContextNodes[depth].siblings[selectorIdx].chosen = true;
        });
      }
    });
  }
  return parsedContextNodes;
}
function setTaggingExclusions(classExclusions = [], idExclusions = []) {
  taggingExclusions.classExclusions = classExclusions;
  taggingExclusions.idExclusions = idExclusions;
}
function updateSelectorValue(selectorNodes, selectorValueObject) {
  // find node based on id of object
  const nodeId = selectorValueObject.id.split('s', 1)[0];
  const selectorGroupType = selectorValueObject.id.includes('ss') ? 'siblings' : 'selectors';
  const nodeIndex = selectorNodes.findIndex(node => node.id === nodeId);
  if (selectorNodes[nodeIndex]) {
    const selectorGroupIndex = selectorNodes[nodeIndex][selectorGroupType].findIndex(selector => selector.id === selectorValueObject.id);
    const selector = selectorNodes[nodeIndex][selectorGroupType][selectorGroupIndex];
    selectorNodes[nodeIndex][selectorGroupType].splice(selectorGroupIndex, 1, {
      ...selector,
      value: selectorValueObject.value,
      editStyle: selectorValueObject.editStyle,
      chosen: true
    });
  }
  return selectorNodes;
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$8 = {
  name: 'CustomRuleBuilder',
  components: {
    CustomRuleSelect: __vue_component__$9,
    PendoToggle
  },
  props: {
    nodePrefix: {
      default: '',
      type: String
    },
    customRule: {
      default: '',
      type: String
    },
    target: {
      default: () => {},
      type: Object
    },
    classExclusions: {
      default: () => [],
      type: Array
    },
    idExclusions: {
      default: () => [],
      type: Array
    },
    numMatches: {
      default: 0,
      type: Number
    },
    configurable: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      currentRule: '',
      selectorNodes: [],
      showUnusedNodes: false,
      numUnused: 0
    };
  },
  computed: {
    numUnusedLabel() {
      return this.numUnused === 1 ? 'Show 1 unused node' : `Show ${this.numUnused} unused nodes`;
    }
  },
  watch: {
    customRule: {
      handler(newCustomRule) {
        this.refreshSelectorNodeData(this.target, newCustomRule);
        this.customRuleSelectChange({
          currentRule: newCustomRule
        });
      },
      immediate: true
    },
    target(newTarget) {
      this.refreshSelectorNodeData(newTarget, this.customRule);
    }
  },
  mounted() {
    selectorEvent.$on('apply-click', event => {
      this.selectorNodes = updateSelectorValue(this.selectorNodes, event);
    });
  },
  methods: {
    refreshSelectorNodeData(target, customRule) {
      setTaggingExclusions(this.classExclusions, this.idExclusions);
      this.selectorNodes = generateSelectorNodeData(target, customRule, this.nodePrefix);
    },
    customRuleSelectChange(customRuleSelectRule) {
      this.numUnused = customRuleSelectRule.numUnused;
      if (this.currentRule !== customRuleSelectRule.currentRule) {
        this.currentRule = customRuleSelectRule.currentRule;
        this.$emit('changed-rule', this.currentRule);
      }
    },
    updateUnusedNodeVisibility() {
      this.showUnusedNodes = !this.showUnusedNodes;
    }
  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('custom-rule-select', {
    staticClass: "crb-custom-select",
    attrs: {
      "selector-nodes": _vm.selectorNodes,
      "configurable": _vm.configurable,
      "show-unused-nodes": _vm.showUnusedNodes
    },
    on: {
      "changed-rule": _vm.customRuleSelectChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "crb-bottom"
  }, [_c('p', {
    staticClass: "crb-matches"
  }, [_vm._v("\n            " + _vm._s(_vm.numMatches === 1 ? _vm.numMatches + " match found" : _vm.numMatches + " matches found") + "\n        ")]), _vm._v(" "), _c('pendo-toggle', {
    staticClass: "crb-toggle",
    attrs: {
      "value": _vm.showUnusedNodes,
      "label-position": "left",
      "label": _vm.numUnusedLabel
    },
    on: {
      "change": _vm.updateUnusedNodeVisibility
    }
  })], 1)], 1);
};
var __vue_staticRenderFns__$8 = [];

/* style */
const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-087da8a3_0", {
    source: ".crb-custom-select[data-v-087da8a3]{border:1px solid #000;border-radius:5px}.crb-matches[data-v-087da8a3]{font-family:Inter;font-size:12px}.crb-toggle[data-v-087da8a3]{justify-content:flex-end;flex:2;font-family:Inter}.crb-toggle .pendo-toggle__label[data-v-087da8a3]{color:#6a6c75;font-weight:100;font-size:12px}.crb-bottom[data-v-087da8a3]{display:flex}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$8 = "data-v-087da8a3";
/* module identifier */
const __vue_module_identifier__$8 = undefined;
/* functional template */
const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce$1;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;

var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter$1;

var deburrLetter = _deburrLetter,
    toString$4 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$3 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$4(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr$1;

/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;

/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;

/** Used to compose unicode character classes. */

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$2 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;

var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$3 = toString_1,
    unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$3(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words$1;

var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$1(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder$1;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$2(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

var _castSlice = castSlice$2;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$2(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$2;

var castSlice$1 = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray$1 = _stringToArray,
    toString$2 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$2(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray$1(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice$1(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;

var createCompounder = _createCompounder,
    upperFirst = upperFirst_1;

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

var startCase_1 = startCase;

var startCase$1 = /*@__PURE__*/getDefaultExportFromCjs(startCase_1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$7 = {
  name: 'FeaturesButton',
  components: {
    PendoIcon,
    PendoLoadingIndicator
  },
  directives: {
    PendoTooltip
  },
  props: {
    count: {
      type: Number,
      default: 0
    },
    countColor: {
      type: String,
      required: true
    },
    countBackgroundColor: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countStyles() {
      return {
        color: `${this.countColor}`,
        backgroundColor: `${this.countBackgroundColor}`
      };
    },
    tooltipLabel() {
      return `${startCase$1(this.type)} are loading.`;
    }
  },
  methods: {
    emitClick() {
      if (!this.loading) {
        this.$emit('onNavigationClick');
      }
    }
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        arrow: true,
        content: _vm.loading ? _vm.tooltipLabel : null,
        boundariesElement: 'viewport',
        delay: {
          show: 300,
          hide: 0
        }
      },
      expression: "{\n        arrow: true,\n        content: loading ? tooltipLabel : null,\n        boundariesElement: 'viewport',\n        delay: { show: 300, hide: 0 }\n    }"
    }],
    staticClass: "features-button",
    class: {
      disabled: _vm.loading
    },
    on: {
      "click": _vm.emitClick
    }
  }, [_c('div', {
    staticClass: "features-button--start"
  }, [_c('div', {
    staticClass: "features-button--start-count",
    style: _vm.countStyles
  }, [_vm.loading ? _c('pendo-loading-indicator', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_vm._v("\n                " + _vm._s(_vm.count) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "features-button--start-labels"
  }, [_c('div', {
    staticClass: "features-button--start-labels-type"
  }, [_vm._v("\n                " + _vm._s(_vm.type) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "features-button--start-labels-description"
  }, [_vm._v("\n                " + _vm._s(_vm.description) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "features-button--end"
  }, [_c('pendo-icon', {
    attrs: {
      "type": "chevron-right",
      "size": "16",
      "stroke": "#2A2C35"
    }
  })], 1)]);
};
var __vue_staticRenderFns__$7 = [];

/* style */
const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-332cfda8_0", {
    source: ".features-button{height:72px;padding:16px;border:1px solid #dadce5;border-radius:3px;display:flex;justify-content:space-between;align-items:center}.features-button.disabled:hover{background-color:#f8f8f9;cursor:not-allowed}.features-button:not(.disabled):hover{background-color:#f8f8f9;cursor:pointer}.features-button--start{display:flex;gap:8px}.features-button--start-count{border-radius:50%;width:40px;height:40px;display:flex;justify-content:center;align-items:center;font-size:16px;font-weight:700;line-height:120%}.features-button--start-labels-type{font-size:14.22px;font-weight:600;line-height:135%;color:#2a2c35}.features-button--start-labels-description{font-size:12.64px;font-weight:400;line-height:150%;color:#6a6c75}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$7 = undefined;
/* module identifier */
const __vue_module_identifier__$7 = undefined;
/* functional template */
const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$6 = {
  name: 'PageRuleTester',
  components: {
    PendoModal,
    PendoForm,
    PendoFormItem,
    PendoButton,
    PendoInput,
    PendoAlert
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    /**
     * wrapper for `@pendo/http` client
     * client.http.post()
     */
    client: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: 'Save Rule'
    },
    /**
     * @typedef {Object} ruleObj
     * @property {string} rule - The rule property of the rule object. A page rule like: `//*` or `//about`.
     * @property {string} ruleType - The ruleType property of the rule object. Either "exclude" or "include".
     */
    ruleObj: {
      type: Object,
      required: true
    },
    showNormalization: {
      type: Boolean,
      default: false
    },
    pageRules: {
      type: Object,
      default: () => ({
        rules: [],
        excludeRules: []
      })
    }
  },
  data() {
    return {
      form: {
        url: '',
        urlNormalize: '',
        rule: ''
      },
      rules: {
        url: [{
          required: true,
          message: 'required',
          trigger: 'blur'
        }, {
          validator: this.validateUrl,
          trigger: ['blur', 'change']
        }],
        rule: [{
          required: true,
          message: 'required',
          trigger: 'blur'
        }, {
          validator: this.validateRule,
          trigger: ['blur', 'change']
        }]
      },
      isMatch: false,
      isFormValid: false
    };
  },
  computed: {
    ruleChanged() {
      return this.form.rule !== this.ruleObj.rule;
    },
    duplicateRules() {
      const dupes = [];
      const currentRule = this.form.rule;
      const ruleType = this.ruleObj.type;
      if (!ruleType) {
        return dupes;
      }
      const rulesToCheck = ruleType === 'exclude' ? this.pageRules.includeRules : this.pageRules.excludeRules;
      if (rulesToCheck && rulesToCheck.length) {
        rulesToCheck.forEach(rule => {
          if (rule.rule === currentRule) {
            const type = ruleType === 'exclude' ? 'include' : 'exclude';
            dupes.push({
              type,
              rule: rule.rule
            });
          }
        });
      }
      return dupes;
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetModal();
        this.form.rule = this.ruleObj.rule;
        this.sendTrackEventOpen({
          superUser: this.showNormalization,
          ruleIn: this.ruleObj.rule
        });
        setTimeout(() => {
          this.validateForm();
        }, 1000);
      }
    }
  },
  methods: {
    close() {
      this.$emit('close', this.ruleObj.rule);
      this.resetModal();
    },
    save() {
      this.$emit('close', this.form.rule);
      this.sendTrackEventUpdate({
        superUser: this.showNormalization,
        ruleIn: this.ruleObj.rule,
        ruleOut: this.form.rule,
        isFormValid: this.isFormValid
      });
      this.resetModal();
    },
    async validateUrl(rule, value, cb) {
      const startWithProtocolRegex = new RegExp('^https?://');
      const url = startWithProtocolRegex.test(this.form.url) ? this.form.url : `https://${this.form.url}`;
      try {
        const response = await this.client.http.post('/api/s/_SID_/helper/urlnorm', {
          url
        });
        this.form.urlNormalize = response.data;
        cb();
        return;
      } catch (error) {
        cb(new Error('Incorrect URL'));
      }
      this.form.urlNormalize = '';
    },
    async validateRule(rule, value, cb) {
      const validRuleRegex = new RegExp('^//.*', 'gm');
      this.form.rule = this.form.rule.trim();
      let test = validRuleRegex.test(this.form.rule);
      if (!test) {
        cb(new Error('Rule must start with //'));
        return;
      }
      const response = await this.client.http.post('/api/s/_SID_/helper/urlpatternparse', {
        urlPattern: this.form.rule
      });
      const ruleRegex = new RegExp(response.data.urlRegex);
      test = ruleRegex.test(this.form.urlNormalize);
      if (test) {
        cb();
        this.isMatch = true;
        return;
      }
      cb(new Error('Rule does not match.'));
      this.isMatch = false;
    },
    validateForm() {
      if (this.$refs.form) {
        this.$refs.form.validate(() => {});
      }
    },
    resetModal() {
      this.form.url = '';
      this.form.urlNormalize = '';
      this.form.rule = '';
      this.isMatch = false;
      this.formIsValid = false;
    },
    sendTrackEventOpen({
      superUser = false,
      ruleIn = ''
    }) {
      if (window.pendo) {
        window.pendo.track('pageRuleTestModalOpen', {
          superUser,
          ruleIn
        });
      }
    },
    sendTrackEventUpdate({
      superUser = false,
      ruleIn = '',
      ruleOut = '',
      isFormValid = false
    }) {
      if (window.pendo) {
        window.pendo.track('pageRuleTestModalUpdate', {
          superUser,
          ruleIn,
          ruleOut,
          isFormValid
        });
      }
    }
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('pendo-modal', {
    attrs: {
      "title": "Test Page Rule",
      "height": "auto",
      "max-width": "450px",
      "show-close": false,
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('pendo-form', {
          ref: "form",
          staticClass: "page-rule-tester--body",
          attrs: {
            "model": _vm.form
          },
          model: {
            value: _vm.isFormValid,
            callback: function ($$v) {
              _vm.isFormValid = $$v;
            },
            expression: "isFormValid"
          }
        }, [_c('pendo-form-item', {
          attrs: {
            "prop": "url",
            "rules": _vm.rules.url
          }
        }, [_c('pendo-input', {
          attrs: {
            "label": "Test URL",
            "debounce": 1000
          },
          on: {
            "input": _vm.validateForm
          },
          model: {
            value: _vm.form.url,
            callback: function ($$v) {
              _vm.$set(_vm.form, "url", $$v);
            },
            expression: "form.url"
          }
        })], 1), _vm._v(" "), _vm.showNormalization ? _c('pendo-form-item', [_c('pendo-input', {
          attrs: {
            "readonly": "",
            "label": "Normalized Test URL"
          },
          model: {
            value: _vm.form.urlNormalize,
            callback: function ($$v) {
              _vm.$set(_vm.form, "urlNormalize", $$v);
            },
            expression: "form.urlNormalize"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('pendo-form-item', {
          attrs: {
            "prop": "rule",
            "rules": _vm.rules.rule
          }
        }, [_c('pendo-input', {
          attrs: {
            "label": "Rule",
            "debounce": 1000
          },
          model: {
            value: _vm.form.rule,
            callback: function ($$v) {
              _vm.$set(_vm.form, "rule", $$v);
            },
            expression: "form.rule"
          }
        }), _vm._v(" "), _vm.isMatch ? _c('div', {
          staticClass: "page-rule-tester-body-rule-status-success"
        }, [_c('i', {
          staticClass: "fa fa-check",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" URL matches the page rule!\n                ")]) : _vm._e(), _vm._v(" "), !_vm.isMatch ? _c('div', {
          staticClass: "page-rule-tester-body-rule-status-error"
        }, [_c('a', {
          attrs: {
            "href": "https://support.pendo.io/hc/en-us/articles/360032293371-Understanding-URLs-for-page-tagging",
            "target": "_blank"
          }
        }, [_vm._v("\n                        Need help?\n                    ")])]) : _vm._e()], 1)], 1), _vm._v(" "), !!_vm.duplicateRules.length ? _c('pendo-alert', {
          attrs: {
            "type": "error",
            "title": "Error with Tested Rule"
          }
        }, _vm._l(_vm.duplicateRules, function (dupe, index) {
          return _c('div', {
            key: index
          }, [_vm._v("\n                Conflicting " + _vm._s(dupe.type) + " rule " + _vm._s(dupe.rule) + ". Exclude Rules cannot match include Rules.\n            ")]);
        }), 0) : _vm._e()];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('pendo-button', {
          attrs: {
            "label": "" + (_vm.ruleChanged ? 'Cancel' : 'Done'),
            "type": "secondary"
          },
          on: {
            "click": _vm.close
          }
        }), _vm._v(" "), _vm.ruleChanged ? _c('pendo-button', {
          attrs: {
            "disabled": !!_vm.duplicateRules.length,
            "theme": "app",
            "label": _vm.label
          },
          on: {
            "click": _vm.save
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$6 = [];

/* style */
const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-2e9258de_0", {
    source: ".page-rule-tester--body[data-v-2e9258de]{display:flex;flex-direction:column;gap:20px}.page-rule-tester--body .page-rule-tester-body-rule-status-success[data-v-2e9258de]{color:#00aa62}.page-rule-tester--body .page-rule-tester-body-rule-status-error[data-v-2e9258de]{color:red}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$6 = "data-v-2e9258de";
/* module identifier */
const __vue_module_identifier__$6 = undefined;
/* functional template */
const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$5 = {
  name: 'PagesButton',
  components: {
    PendoIcon,
    PendoTag
  },
  directives: {
    PendoTooltip
  },
  props: {
    type: {
      type: String,
      default: 'Frame'
    },
    activeUrl: {
      type: String,
      default: ''
    },
    tagged: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasIncludeOrExcludePages: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayUrl() {
      if (!this.activeUrl) {
        return;
      }
      return this.activeUrl.replace(/https?:\/\//, '');
    }
  },
  methods: {
    emitClick() {
      if (this.disabled) {
        return;
      }
      if (this.tagged || this.hasIncludeOrExcludePages) {
        this.$emit('onNavigationClick');
      } else {
        this.$emit('onTagPageClick');
      }
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        arrow: true,
        content: _vm.activeUrl,
        boundariesElement: 'viewport',
        delay: {
          show: 300,
          hide: 0
        }
      },
      expression: "{\n        arrow: true,\n        content: activeUrl,\n        boundariesElement: 'viewport',\n        delay: { show: 300, hide: 0 }\n    }"
    }],
    staticClass: "pages-button",
    class: {
      disabled: _vm.disabled
    },
    on: {
      "click": _vm.emitClick
    }
  }, [_c('div', {
    staticClass: "pages-button--left"
  }, [_c('div', {
    staticClass: "pages-button--left-top"
  }, [_c('pendo-tag', {
    attrs: {
      "label": "" + (_vm.tagged ? 'Tagged' : 'Untagged'),
      "type": "" + (_vm.tagged ? 'success' : 'warning'),
      "size": "mini",
      "round": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pages-button--left-top-type"
  }, [_vm._v("\n                " + _vm._s(_vm.type) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pages-button--left-bottom"
  }, [_vm._v("\n            " + _vm._s(_vm.displayUrl) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "pages-button--right"
  }, [_c('pendo-icon', {
    attrs: {
      "type": "chevron-right",
      "size": "16",
      "stroke": "#2A2C35"
    }
  })], 1)]);
};
var __vue_staticRenderFns__$5 = [];

/* style */
const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-c6e3864c_0", {
    source: ".pages-button[data-v-c6e3864c]{height:56px;border:1px solid #dadce5;border-radius:3px;padding:8px 16px;display:flex;justify-content:space-between;align-items:center}.pages-button.disabled[data-v-c6e3864c]:hover{background-color:#f8f8f9;cursor:not-allowed}.pages-button[data-v-c6e3864c]:not(.disabled):hover{background-color:#f8f8f9;cursor:pointer}.pages-button--left[data-v-c6e3864c]{width:90%}.pages-button--left-top[data-v-c6e3864c]{display:flex;align-items:center;gap:7px;margin-bottom:4px}.pages-button--left-top-type[data-v-c6e3864c]{font-size:14.22px;font-weight:600;line-height:135%;color:#2a2c35}.pages-button--left-bottom[data-v-c6e3864c]{font-size:12.64px;font-weight:400;line-height:150%;text-overflow:ellipsis;overflow:hidden;text-wrap:nowrap;color:#6a6c75}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$5 = "data-v-c6e3864c";
/* module identifier */
const __vue_module_identifier__$5 = undefined;
/* functional template */
const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$4 = {
  name: 'RepeatingComponent',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  props: {
    repeatingData: {
      type: Array,
      default: () => []
    },
    /**
     * Key to compare objects in `repeatingData`
     */
    idKey: {
      type: String,
      default: 'repeatingKey'
    },
    unit: {
      type: String,
      default: 'item'
    },
    allowEmpty: {
      type: Boolean,
      defaut: false
    }
  },
  emits: ['addItem', 'removeItem'],
  data() {
    return {
      itemKeyForHover: ''
    };
  },
  computed: {
    disableDelete() {
      return !this.allowEmpty && this.repeatingData.length === 1;
    },
    unitDisplayName() {
      return startCase$1(this.unit);
    },
    tooltipConfig() {
      return {
        multiline: true,
        arrow: true,
        placement: 'top-start',
        container: '.repeating-component',
        content: `Remove ${this.unitDisplayName}`
      };
    }
  },
  watch: {
    repeatingData: {
      handler(newVal) {
        if (!this.allowEmpty && isEmpty$1(newVal)) {
          this.addItem();
        }
      },
      immediate: true
    }
  },
  methods: {
    removeItem(index) {
      this.$emit('removeItem', index);
    },
    addItem() {
      this.$emit('addItem');
    }
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "repeating-component"
  }, [_c('div', {
    staticClass: "repeating-component__header"
  }, [_vm._t("header")], 2), _vm._v(" "), _vm._t("description"), _vm._v(" "), _vm.repeatingData ? _c('div', [_c('TransitionGroup', {
    attrs: {
      "name": "repeating-items"
    }
  }, _vm._l(_vm.repeatingData, function (item, index) {
    return _c('div', {
      key: item[_vm.idKey],
      ref: "items",
      refInFor: true,
      staticClass: "repeating-component__item",
      class: {
        'repeating-component__item-hover': _vm.itemKeyForHover === item[_vm.idKey] && !_vm.disableDelete
      },
      attrs: {
        "data-cy": "repeating-component__item"
      }
    }, [_vm._t("default", null, {
      "index": index,
      "item": item
    }), _vm._v(" "), _c('div', {
      staticClass: "repeating-component__item-remove-wrapper",
      on: {
        "mouseenter": function ($event) {
          _vm.itemKeyForHover = item[_vm.idKey];
        },
        "mouseleave": function ($event) {
          _vm.itemKeyForHover = '';
        }
      }
    }, [_c('pendo-button', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: _vm.tooltipConfig,
        expression: "tooltipConfig"
      }],
      staticClass: "repeating-component__item-remove-wrapper-remove",
      attrs: {
        "type": "tertiary",
        "icon": "trash-2",
        "icon-size": "18",
        "disabled": _vm.disableDelete
      },
      on: {
        "click": function ($event) {
          return _vm.removeItem(index);
        }
      }
    })], 1)], 2);
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('pendo-button', {
    staticClass: "repeating-component__item-add",
    attrs: {
      "theme": "app",
      "type": "secondary",
      "prefix-icon": "plus",
      "data-cy": "New " + _vm.unitDisplayName,
      "label": "New " + _vm.unitDisplayName
    },
    on: {
      "click": _vm.addItem
    }
  })], 2);
};
var __vue_staticRenderFns__$4 = [];

/* style */
const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-6be8d7f1_0", {
    source: ".repeating-component__header{font-weight:700}.repeating-component__item{display:flex;margin-top:8px;transition-property:background-color;transition-duration:.2s}.repeating-component__item-remove-wrapper{height:36px}.repeating-component__item-remove-wrapper-remove{width:36px;margin-left:5px}.repeating-component__item-hover{background-color:#f4f4f7}.repeating-component__item-add{margin-top:8px}.repeating-items-enter-active,.repeating-items-leave-active{transition:height .3s linear}.repeating-items-enter-from,.repeating-items-leave-to{transition:height .3s linear}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$4 = undefined;
/* module identifier */
const __vue_module_identifier__$4 = undefined;
/* functional template */
const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var isArray$3 = isArray_1,
    isSymbol$1 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray$3(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$1;

var MapCache$1 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$1);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$1;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

var isArray$2 = isArray_1,
    isKey = _isKey,
    stringToPath = _stringToPath,
    toString$1 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$1(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString$1(value));
}

var _castPath = castPath$1;

var isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$1(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey$1;

var castPath = _castPath,
    toKey = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$1;

var baseGet = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

var get$1 = /*@__PURE__*/getDefaultExportFromCjs(get_1);

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;

var _SetCache = SetCache$2;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$3(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$3;

var baseIndexOf$2 = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf$2(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    arrayMap = _arrayMap,
    baseUnary = _baseUnary,
    cacheHas$1 = _cacheHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference$1(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas$1;
    isCommon = false;
    values = new SetCache$1(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

var _baseDifference = baseDifference$1;

var Symbol$1 = _Symbol,
    isArguments = isArguments_1,
    isArray$1 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$1(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$2(value) {
  return value;
}

var identity_1 = identity$2;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$1(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$1;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;

var constant = constant_1,
    defineProperty = _defineProperty,
    identity$1 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty ? identity$1 : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$1 = shortOut(baseSetToString);

var _setToString = setToString$1;

var identity = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

var _baseRest = baseRest$1;

var isArrayLike = isArrayLike_1,
    isObjectLike$1 = isObjectLike_1;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$1(value) {
  return isObjectLike$1(value) && isArrayLike(value);
}

var isArrayLikeObject_1 = isArrayLikeObject$1;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

var baseDifference = _baseDifference,
    baseFlatten = _baseFlatten,
    baseRest = _baseRest,
    isArrayLikeObject = isArrayLikeObject_1,
    last = last_1;

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

var differenceWith_1 = differenceWith;

var differenceWith$1 = /*@__PURE__*/getDefaultExportFromCjs(differenceWith_1);

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$1) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol = _Symbol,
    Uint8Array = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var Stack = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray = isArray_1,
    isBuffer = isBufferExports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$1(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
}

var _baseIsEqual = baseIsEqual$1;

var baseIsEqual = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

var isEqual$1 = /*@__PURE__*/getDefaultExportFromCjs(isEqual_1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const MAX_HEIGHT = 420;
var script$3 = {
  name: 'SuggestedPagesTable',
  components: {
    PendoActionsCell,
    PendoButton,
    PendoTable,
    PendoEditableContent,
    PendoEmptyState,
    PendoModal,
    PendoIcon,
    PendoPopover,
    CountableTableExpander: __vue_component__$c
  },
  props: {
    title: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      default: () => [{
        type: 'checkbox'
      }, {
        prop: 'name',
        label: 'Page Name',
        sortable: true,
        width: 400
      }, {
        prop: 'rule',
        label: 'Include Rules',
        sortable: true,
        width: 300
      }, {
        prop: 'samples',
        label: 'Sample URLs',
        sortable: true,
        width: 500
      }, {
        prop: 'application',
        label: 'Application',
        sortable: true
      }, {
        sortable: true,
        prop: 'numLoads',
        label: 'Number of Views',
        async: true,
        formatter: row => get$1(row, 'numLoads', 0),
        width: 150
      }, {
        prop: 'actions',
        label: '',
        width: 100
      }]
    },
    pages: {
      type: Array,
      required: true
    },
    sampleTimeMessage: {
      type: String,
      default: '6 days'
    },
    theme: {
      type: String,
      default: 'app',
      validator: theme => ['app', 'dark', 'p2', 'p2-light', 'p2-dark'].includes(theme)
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    resizable: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isDeleting: {
      type: Boolean,
      default: false
    },
    isAccepting: {
      type: Boolean,
      default: false
    },
    disableNotifications: {
      type: Boolean,
      default: false
    },
    isDefaultCollapsed: {
      type: Boolean,
      default: true
    },
    filters: {
      type: [Object, Array],
      default: null
    }
  },
  data() {
    return {
      expandedSamples: {},
      selectedPages: [],
      status: null,
      selectedRow: null,
      showConfirmDeleteModal: false,
      showSuggestedPagesTableSettings: false,
      MAX_HEIGHT
    };
  },
  computed: {
    tableStatus() {
      const LOADING_STATES = {
        EMPTY: 'empty'
      };
      return this.pages.length === 0 ? LOADING_STATES.EMPTY : '';
    },
    confirmDeleteMessage() {
      let message = this.multiplePagesSelected ? `${this.selectedPages.length} suggested pages` : '1 suggested page';
      message += ' will no longer be accessible and cannot be recovered. This action cannot be undone.';
      return message;
    },
    confirmButtonConfig() {
      const label = this.multiplePagesSelected ? 'Delete Suggested Pages' : 'Delete Suggested Page';
      return {
        type: 'danger',
        label,
        theme: this.theme,
        loading: this.isDeleting
      };
    },
    multiplePagesSelected() {
      return !this.selectedRow && this.selectedPages && this.selectedPages.length > 1;
    },
    hasTooltipTextSlot() {
      return !!this.$slots.tooltipText;
    }
  },
  watch: {
    isDeleting(isDeleting) {
      if (this.showConfirmDeleteModal && !isDeleting) {
        this.showConfirmDeleteModal = false;
        this.selectedPages = {};
      }
    },
    pages(newValue, oldValue) {
      const differenceArray = differenceWith$1(oldValue, newValue, isEqual$1);
      const processedAllPages = isEqual$1(differenceArray, this.selectedPages);
      if (processedAllPages) {
        this.selectedPages = [];
      } else {
        const remainingPages = differenceWith$1(this.selectedPages, differenceArray, isEqual$1);
        this.selectedPages = remainingPages;
      }
    }
  },
  mounted() {
    if (this.isDefaultCollapsed) {
      this.collapseSuggestedPagesTable();
    }
  },
  methods: {
    acceptBulk() {
      if (this.selectedPages.length > 0) {
        this.$emit('accept-bulk', this.selectedPages);
      }
    },
    toggleConfirmDeleteModal(value, row) {
      this.selectedRow = null;
      this.showConfirmDeleteModal = value;
      if (value && row) {
        this.selectedRow = row;
      }
    },
    confirmDelete() {
      if (this.selectedRow) {
        this.$emit('delete-one', this.selectedRow);
      } else {
        this.$emit('delete-bulk', this.selectedPages);
      }
    },
    acceptOne(row) {
      this.$emit('accept-one', row);
    },
    pageSelected(event) {
      this.selectedPages = event.selectedRows;
    },
    resetFilters() {
      this.selectedPages = [];
      this.$emit('reset-filters', true);
    },
    collapseSuggestedPagesTable() {
      this.$refs.suggestedPagesTable.collapseTable();
    },
    collapseChange(event) {
      this.$emit('collapse-change', event);
    },
    onSamplesExpanded(row, expanded) {
      this.$set(this.expandedSamples, row.id, expanded);
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('main', {
    staticClass: "suggested-pages-table"
  }, [_c('pendo-table', {
    ref: "suggestedPagesTable",
    attrs: {
      "title": _vm.title,
      "data": _vm.pages,
      "columns": _vm.columns,
      "max-height": _vm.MAX_HEIGHT,
      "row-key": _vm.rowKey,
      "status": _vm.tableStatus,
      "resizable": _vm.resizable,
      "loading": _vm.loading,
      "checkbox-config": {
        reserve: true
      },
      "filters": _vm.filters,
      "collapsible": ""
    },
    on: {
      "select-change": function ($event) {
        return _vm.pageSelected($event);
      },
      "collapse-change": _vm.collapseChange
    },
    scopedSlots: _vm._u([{
      key: "headerPrefix",
      fn: function () {
        return [!_vm.disableNotifications && !_vm.isEmpty ? _c('div', {
          staticClass: "red-dot"
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "headerActions",
      fn: function () {
        return [_vm.hasTooltipTextSlot ? _c('pendo-popover', {
          staticClass: "suggested-pages-popover",
          attrs: {
            "delay": {
              show: 0,
              hide: 750
            },
            "arrow": true,
            "theme": "light"
          },
          scopedSlots: _vm._u([{
            key: "popover",
            fn: function () {
              return [_c('div', {
                staticClass: "suggested-pages-table-popover-container"
              }, [_c('div', {
                staticClass: "suggested-pages-table-popover-text"
              }, [_c('pendo-icon', {
                staticClass: "popover-text-info-icon",
                attrs: {
                  "type": "info",
                  "size": "16"
                }
              }), _vm._v(" "), _vm._t("tooltipText")], 2)])];
            },
            proxy: true
          }], null, true)
        }, [_c('pendo-icon', {
          attrs: {
            "type": "info",
            "size": "16"
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm.selectedPages.length > 0 ? _c('div', {
          staticClass: "selected-actions"
        }, [_c('span', {
          staticClass: "header-divider"
        }, [_vm._v("|")]), _vm._v(" "), _c('pendo-button', {
          staticClass: "suggested-actions",
          attrs: {
            "theme": _vm.theme,
            "label": _vm.selectedPages.length === 1 ? 'Accept Tag' : 'Accept Tags',
            "loading": _vm.isAccepting,
            "prefix-icon": "check-square",
            "type": "tertiary"
          },
          on: {
            "click": _vm.acceptBulk
          }
        }), _vm._v(" "), _c('pendo-button', {
          staticClass: "suggested-actions",
          attrs: {
            "theme": _vm.theme,
            "label": _vm.selectedPages.length === 1 ? 'Delete Tag' : 'Delete Tags',
            "prefix-icon": "trash-2",
            "type": "tertiary"
          },
          on: {
            "click": function ($event) {
              return _vm.toggleConfirmDeleteModal(true);
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "info-text"
        }, [_vm._v("\n                The data in this table is sampled and reflects the last " + _vm._s(_vm.sampleTimeMessage) + "\n            ")])];
      },
      proxy: true
    }, {
      key: "name",
      fn: function (ref) {
        var row = ref.row;
        return [_c('div', {
          staticClass: "suggested-pages-table--name"
        }, [_c('pendo-editable-content', {
          staticClass: "suggested-pages-table--name--inline-edit",
          scopedSlots: _vm._u([{
            key: "append",
            fn: function (ref) {
              var confirm = ref.confirm;
              var cancel = ref.cancel;
              var pending = ref.pending;
              return [_c('pendo-button', {
                attrs: {
                  "loading": pending,
                  "theme": "app",
                  "icon": "check",
                  "type": "primary"
                },
                on: {
                  "click": confirm
                }
              }), _vm._v(" "), _c('pendo-button', {
                attrs: {
                  "theme": "app",
                  "type": "secondary",
                  "icon": "x"
                },
                on: {
                  "click": cancel
                }
              })];
            }
          }], null, true),
          model: {
            value: row.name,
            callback: function ($$v) {
              _vm.$set(row, "name", $$v);
            },
            expression: "row.name"
          }
        })], 1)];
      }
    }, {
      key: "samples",
      fn: function (ref) {
        var row = ref.row;
        return [_c('div', {
          staticClass: "suggested-pages-table--samples"
        }, [_c('countable-table-expander', {
          attrs: {
            "data": row.samples,
            "data-units": "URLs",
            "is-expanded": !!_vm.expandedSamples[row.id]
          },
          on: {
            "expanded": function ($event) {
              return _vm.onSamplesExpanded(row, $event);
            }
          }
        })], 1)];
      }
    }, {
      key: "actions",
      fn: function (ref) {
        var row = ref.row;
        return [_c('pendo-actions-cell', {
          attrs: {
            "row": row,
            "actions": [{
              type: 'accept',
              icon: 'check-square',
              tooltip: 'Accept Tag'
            }, {
              type: 'delete',
              icon: 'trash-2',
              tooltip: 'Delete Tag'
            }]
          },
          on: {
            "delete": function ($event) {
              return _vm.toggleConfirmDeleteModal(true, row);
            },
            "accept": function ($event) {
              return _vm.acceptOne(row);
            }
          }
        })];
      }
    }, {
      key: "empty",
      fn: function () {
        return [_vm.isEmpty ? _c('pendo-empty-state', {
          attrs: {
            "title": "Come back later",
            "description": "No pages with click events have been detected in the past " + _vm.sampleTimeMessage
          },
          scopedSlots: _vm._u([{
            key: "icon",
            fn: function () {
              return [_c('img', {
                staticClass: "suggested-pages-table__empty-icon",
                attrs: {
                  "src": "https://cdn.pendo.io/img/suggested-pages-empty-state.png"
                }
              })];
            },
            proxy: true
          }], null, false, 4268652246)
        }) : _c('pendo-empty-state', {
          attrs: {
            "title": "No more to accept here!",
            "description": "Reset your filters to see the full list of the suggested pages you need to take action on."
          },
          scopedSlots: _vm._u([{
            key: "icon",
            fn: function () {
              return [_c('img', {
                staticClass: "suggested-pages-table__filter-icon",
                attrs: {
                  "src": "https://cdn.pendo.io/img/suggested-pages-filter-state.png"
                }
              })];
            },
            proxy: true
          }, {
            key: "actions",
            fn: function () {
              return [_c('pendo-button', {
                attrs: {
                  "theme": _vm.theme,
                  "type": "primary",
                  "label": "Reset Filters"
                },
                on: {
                  "click": _vm.resetFilters
                }
              })];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('pendo-modal', {
    attrs: {
      "visible": _vm.showConfirmDeleteModal,
      "type": "confirmation",
      "title": _vm.multiplePagesSelected ? 'Delete Suggested Pages?' : 'Delete Suggested Page?',
      "message": _vm.confirmDeleteMessage,
      "confirm-button-config": _vm.confirmButtonConfig,
      "cancel-button-config": {
        type: 'secondary',
        label: 'Cancel'
      }
    },
    on: {
      "cancel": function ($event) {
        return _vm.toggleConfirmDeleteModal(false);
      },
      "confirm": _vm.confirmDelete
    }
  })], 1);
};
var __vue_staticRenderFns__$3 = [];

/* style */
const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-115f7396_0", {
    source: ".suggested-pages-table .red-dot{height:8px;width:8px;border-radius:50%;background-color:red;margin-right:8px}.suggested-pages-table .pendo-table__title{justify-content:start}.suggested-pages-table .pendo-table__title-actions{display:contents}.suggested-pages-table .header-divider{font-size:25px;color:#6a6c75;align-content:right;margin-left:15px;margin-right:15px}.suggested-pages-table .suggested-actions{color:#128297!important}.suggested-pages-table__empty-icon{width:185px}.suggested-pages-table__filter-icon{width:220px}.suggested-pages-table .pendo-table__empty-block{height:333px}.suggested-pages-table .info-text{display:flex;justify-content:end;align-items:center;gap:10px;font-family:Inter;font-size:14px;font-style:normal;font-weight:400;line-height:17px;letter-spacing:0;color:#6a6c75;padding-left:8px;margin-left:auto;margin-right:8px}.suggested-pages-table .selected-actions{display:flex;align-items:center}.suggested-pages-table .suggested-pages-popover{margin-left:2px}.suggested-pages-table-popover-text{font-size:12px;line-height:normal}.suggested-pages-table-popover-text .popover-text-info-icon{position:absolute;top:14px;left:10px}.suggested-pages-table-popover-container{margin:8px 20px 8px 26px;width:250px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$3 = undefined;
/* module identifier */
const __vue_module_identifier__$3 = undefined;
/* functional template */
const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$2 = {
  name: 'TaggingOnIngestionSettings',
  components: {
    PendoCard,
    PendoToggle,
    PendoModal,
    PendoButton,
    PendoForm,
    PendoFormItem,
    PendoInput
  },
  props: {
    autoFeatureConfig: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showDisableModal: false,
      showEditMaxModal: false,
      form: {
        input: ''
      },
      maxFeaturesInput: '',
      isFormValid: false,
      rules: {
        input: [{
          required: true,
          message: 'Number is required.',
          trigger: ['blur', 'change']
        }, {
          validator: this.validateInput,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: {
    isToggleOn() {
      return get$1(this.autoFeatureConfig, 'enabled', false);
    },
    autoFeatureCount() {
      return get$1(this.autoFeatureConfig, 'autoFeatureCount', 'n/a');
    },
    maxFeatures() {
      return get$1(this.autoFeatureConfig, 'maxFeatures', 'n/a');
    }
  },
  watch: {
    maxFeatures: {
      handler(newValue) {
        this.form.input = newValue;
      },
      immediate: true
    }
  },
  methods: {
    onToggleChange(event) {
      if (!event) {
        this.showDisableModal = true;
      } else {
        this.emitToggleChangeAndCloseModal(event);
      }
    },
    emitToggleChangeAndCloseModal(change) {
      this.$emit('update', 'enabled', change);
      this.showDisableModal = false;
    },
    validateInput(rule, value, callback) {
      if (value < this.autoFeatureCount) {
        callback(new Error(`Max cannot be less than ${this.autoFeatureCount} already created features.`));
      } else if (value > 1500) {
        callback(new Error('Max cannot exceed 1500.'));
      } else {
        callback();
      }
    },
    emitMaxFeaturesChangeAndCloseModal() {
      this.$emit('update', 'maxFeatures', parseInt(this.form.input));
      this.closeEditMaxModal();
    },
    closeEditMaxModal() {
      this.showEditMaxModal = false;
      this.form.input = this.maxFeatures;
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "tagging-on-ingestion-settings"
  }, [_c('pendo-card', {
    attrs: {
      "title": "Automatic Tagging with Custom HTML Attributes"
    },
    scopedSlots: _vm._u([{
      key: "headerRight",
      fn: function () {
        return [_c('pendo-toggle', {
          attrs: {
            "value": _vm.isToggleOn
          },
          on: {
            "change": _vm.onToggleChange
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "tagging-on-ingestion-settings__message"
  }, [_vm._v("\n            Turn this flag on to have Pendo automatically create new Feature tags that contain Custom HTML\n            Attributes. You must first add the attributes to the 'Collect Custom HTML Attributes' section, after\n            which they will be accessible in the dropdown menu below within 15 minutes of being added.\n        ")]), _vm._v(" "), _vm.isToggleOn ? _c('div', {
    staticClass: "tagging-on-ingestion-settings__container"
  }, [_c('div', {
    staticClass: "tagging-on-ingestion-settings__max-features-container"
  }, [_c('div', {
    staticClass: "tagging-on-ingestion-settings__max-features-label"
  }, [_c('span', {
    staticClass: "tagging-on-ingestion-settings__max-features-count"
  }, [_vm._v("\n                        " + _vm._s(_vm.autoFeatureCount) + "/" + _vm._s(_vm.maxFeatures) + "\n                    ")]), _vm._v("\n                    features created\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tagging-on-ingestion-settings__edit-max"
  }, [_c('pendo-button', {
    attrs: {
      "theme": "app",
      "type": "link"
    },
    on: {
      "click": function ($event) {
        _vm.showEditMaxModal = true;
      }
    }
  }, [_vm._v("\n                        Edit Max\n                    ")])], 1)])]) : _vm._e()]), _vm._v(" "), _c('pendo-modal', {
    staticClass: "tagging-on-ingestion-settings__edit-max-modal",
    attrs: {
      "visible": _vm.showEditMaxModal,
      "title": "Max Number of Features",
      "height": "auto",
      "width": "520",
      "confirm-button-config": {
        type: 'primary',
        theme: 'app',
        label: 'Save',
        disabled: !_vm.isFormValid
      },
      "cancel-button-config": {
        type: 'secondary',
        theme: 'app',
        label: 'Cancel'
      }
    },
    on: {
      "confirm": _vm.emitMaxFeaturesChangeAndCloseModal,
      "cancel": _vm.closeEditMaxModal,
      "close": _vm.closeEditMaxModal
    }
  }, [_c('div', {
    staticClass: "tagging-on-ingestion-settings__edit-max-modal-message"
  }, [_vm._v("\n            Set the max number of features you want to be created through Automatic Tagging with Custom HTML\n            Attributes. Max cannot exceed 1500.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tagging-on-ingestion-settings__edit-max-modal-input"
  }, [_c('pendo-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    },
    model: {
      value: _vm.isFormValid,
      callback: function ($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('pendo-form-item', {
    attrs: {
      "prop": "input",
      "rules": _vm.rules.input
    }
  }, [_c('pendo-input', {
    attrs: {
      "type": "number",
      "width": "mini"
    },
    model: {
      value: _vm.form.input,
      callback: function ($$v) {
        _vm.$set(_vm.form, "input", $$v);
      },
      expression: "form.input"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('pendo-modal', {
    attrs: {
      "visible": _vm.showDisableModal,
      "title": "Warning",
      "height": "auto",
      "confirm-button-config": {
        type: 'danger',
        theme: 'app',
        label: 'Turn Off'
      },
      "cancel-button-config": {
        type: 'secondary',
        theme: 'app',
        label: 'Cancel'
      }
    },
    on: {
      "confirm": function ($event) {
        return _vm.emitToggleChangeAndCloseModal(false);
      },
      "cancel": function ($event) {
        _vm.showDisableModal = false;
      },
      "close": function ($event) {
        _vm.showDisableModal = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('div', {
          staticClass: "tagging-on-ingestion-settings__toggle-modal-message"
        }, [_c('div', [_vm._v("\n                    By turning off this setting, you are opting out of automatic creation of feature tags. This will\n                    not impact feature tags that have already been created.\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("\n                    For questions, please reach out directly to your Pendo support representative or\n                    "), _c('a', {
          attrs: {
            "href": "mailto:support@pendo.io"
          }
        }, [_vm._v("contact support.")])])])];
      },
      proxy: true
    }])
  })], 1);
};
var __vue_staticRenderFns__$2 = [];

/* style */
const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-745cf540_0", {
    source: ".tagging-on-ingestion-settings[data-v-745cf540]  .pendo-card__body{padding:0}.tagging-on-ingestion-settings__message[data-v-745cf540]{padding:16px;line-height:1.5}.tagging-on-ingestion-settings__container[data-v-745cf540]{padding:16px;border-bottom:1px solid #dadce5;border-top:1px solid #dadce5}.tagging-on-ingestion-settings__max-features-container[data-v-745cf540]{display:flex;align-items:center;gap:8px;flex-direction:row;width:max-content;padding-left:10px;padding-right:10px;background:#f4f4f7;border-radius:4px}.tagging-on-ingestion-settings__max-features-count[data-v-745cf540]{font-weight:700}.tagging-on-ingestion-settings__edit-max-modal[data-v-745cf540]  .pendo-modal__body{padding:16px}.tagging-on-ingestion-settings__edit-max-modal-message[data-v-745cf540]{color:#9a9ca5;margin-bottom:16px}.tagging-on-ingestion-settings__edit-max-modal-input[data-v-745cf540]{width:max-content}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$2 = "data-v-745cf540";
/* module identifier */
const __vue_module_identifier__$2 = undefined;
/* functional template */
const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var baseIndexOf$1 = _baseIndexOf;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex$1(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf$1(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

var _charsEndIndex = charsEndIndex$1;

var baseIndexOf = _baseIndexOf;

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex$1(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

var _charsStartIndex = charsStartIndex$1;

var baseToString = _baseToString,
    baseTrim = _baseTrim,
    castSlice = _castSlice,
    charsEndIndex = _charsEndIndex,
    charsStartIndex = _charsStartIndex,
    stringToArray = _stringToArray,
    toString = toString_1;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

var trim_1 = trim;

var trim$1 = /*@__PURE__*/getDefaultExportFromCjs(trim_1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1 = {
  name: 'TextareaInput',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    maxCharactersWarn: {
      type: Number,
      default: 200
    },
    maxCharacters: {
      type: Number,
      default: 280
    },
    lineClamp: {
      type: Number,
      default: null
    },
    lineHeight: {
      type: [Number, String],
      default: 20
    },
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  computed: {
    characterCount() {
      return this.inputValue.length;
    },
    showCharacterCount() {
      return this.characterCount >= this.maxCharactersWarn;
    },
    hasValidationError() {
      if (!this.allowEmpty && !trim$1(this.inputValue)) {
        return true;
      }
      return this.inputValue.length > this.maxCharacters;
    },
    inputStyles() {
      return {
        'line-height': `${this.lineHeight}px`
      };
    },
    maxHeight() {
      return this.lineClamp ? this.lineClamp * this.lineHeight : 80;
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.inputValue = newValue.replace(/\n/g, '');
        this.$emit('input', this.inputValue);
        this.$emit('error', this.hasValidationError);
        this.$nextTick(() => {
          this.updateElementSize(this.$refs.textarea);
        });
      },
      immediate: true
    },
    inputValue: {
      handler(newValue) {
        this.inputValue = newValue.replace(/\n/g, '');
        this.$emit('input', this.inputValue);
        this.$emit('error', this.hasValidationError);
        this.$nextTick(() => {
          this.updateElementSize(this.$refs.textarea);
        });
      }
    }
  },
  methods: {
    focus() {
      if (document.activeElement !== this.$refs.textarea) {
        return this.$refs.textarea.focus();
      }
    },
    handleFocus() {
      window.addEventListener('mousedown', this.handleMousedown);
    },
    handleMousedown(event) {
      this.lastMousedownTarget = event.target;
    },
    updateElementSize(el, maxHeight = this.maxHeight) {
      el.style.height = 'auto';
      // default to lineHeight if element scrollHeight is 0
      const currentHeight = el.scrollHeight > 0 ? el.scrollHeight : this.lineHeight;
      const updatedHeight = currentHeight > maxHeight ? maxHeight : currentHeight;
      el.style.height = `${updatedHeight}px`;
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "textarea-input",
    class: {
      'has-error': _vm.hasValidationError,
      'has-character-count': _vm.showCharacterCount || _vm.hasValidationError
    },
    on: {
      "click": _vm.focus
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputValue,
      expression: "inputValue"
    }],
    ref: "textarea",
    staticClass: "textarea-input__input",
    style: _vm.inputStyles,
    attrs: {
      "rows": "1",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "focus": _vm.handleFocus,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.inputValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _vm.showCharacterCount || _vm.hasValidationError ? _c('span', {
    staticClass: "textarea-input__character-count"
  }, [_vm._v("\n        " + _vm._s(_vm.characterCount) + "/" + _vm._s(_vm.maxCharacters) + "\n    ")]) : _vm._e()]);
};
var __vue_staticRenderFns__$1 = [];

/* style */
const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-61568c0f_0", {
    source: ".textarea-input[data-v-61568c0f]{position:relative;width:100%;cursor:text;border:solid 1px #dadce5;padding:8px 12px;border-radius:3px;position:relative;line-height:0;transition:border-color .15s ease-in-out}.textarea-input.has-character-count[data-v-61568c0f]{padding-bottom:14px}.textarea-input.has-error[data-v-61568c0f]{border-color:#db1111}.textarea-input.has-error .textarea-input__character-count[data-v-61568c0f]{color:#db1111}.textarea-input.has-error[data-v-61568c0f]:hover{border-color:#db1111}.textarea-input.has-error[data-v-61568c0f]:focus-within{border-color:#db1111;z-index:1;outline:2px solid #db1111;outline-offset:1px}.textarea-input[data-v-61568c0f]:hover{border-color:#2a2c35}.textarea-input[data-v-61568c0f]:focus-within{border-color:#2a2c35;z-index:1;outline:2px solid #2a2c35;outline-offset:1px}.textarea-input__input[data-v-61568c0f]{font-family:Inter;width:100%;padding:0;border:none;resize:none;border-radius:3px;outline:0}.textarea-input__character-count[data-v-61568c0f]{position:absolute;right:12px;bottom:8px;font-size:12px;color:#6a6c75}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$1 = "data-v-61568c0f";
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'UpDownNav',
  components: {
    PendoButton
  },
  props: {
    upArrowDisabled: {
      required: true,
      type: Boolean
    },
    downArrowDisabled: {
      required: true,
      type: Boolean
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "up-down-nav"
  }, [_vm._t("nav"), _vm._v(" "), _c('pendo-button', {
    staticClass: "up-down-nav--up-arrow",
    attrs: {
      "theme": "app",
      "type": "secondary",
      "icon": "arrow-up",
      "disabled": _vm.upArrowDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('up-arrow-clicked');
      }
    }
  }), _vm._v(" "), _c('pendo-button', {
    staticClass: "up-down-nav--down-arrow",
    attrs: {
      "theme": "app",
      "type": "secondary",
      "icon": "arrow-down",
      "disabled": _vm.downArrowDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('down-arrow-clicked');
      }
    }
  })], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-f202ef2a_0", {
    source: ".up-down-nav[data-v-f202ef2a]{display:flex;align-items:center}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-f202ef2a";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

function install(Vue) {
  if (install.installed) {
    return;
  }
  install.installed = true;

  // * 1 Add new components here * //
  Vue.component('CollapseDetails', __vue_component__$g);
  Vue.component('ConfigureSelector', __vue_component__$d);
  Vue.component('CountableTableExpander', __vue_component__$c);
  Vue.component('CountableTableRules', __vue_component__$b);
  Vue.component('CustomRuleBuilder', __vue_component__$8);
  Vue.component('FeaturesButton', __vue_component__$7);
  Vue.component('PageRuleTester', __vue_component__$6);
  Vue.component('PagesButton', __vue_component__$5);
  Vue.component('RepeatingComponent', __vue_component__$4);
  Vue.component('SelectorEditor', __vue_component__$f);
  Vue.component('SuggestedPagesTable', __vue_component__$3);
  Vue.component('TaggingOnIngestion', __vue_component__$2);
  Vue.component('TextareaInput', __vue_component__$1);
  Vue.component('UpDownNav', __vue_component__);
}

// * 3 Add new components here * //
const TaggingComponents = {
  install,
  CollapseDetails: __vue_component__$g,
  ConfigureSelector: __vue_component__$d,
  CountableTableExpander: __vue_component__$c,
  CountableTableRules: __vue_component__$b,
  CustomRuleBuilder: __vue_component__$8,
  FeaturesButton: __vue_component__$7,
  PageRuleTester: __vue_component__$6,
  PagesButton: __vue_component__$5,
  RepeatingComponent: __vue_component__$4,
  SelectorEditor: __vue_component__$f,
  SuggestedPagesTable: __vue_component__$3,
  TaggingOnIngestionSettings: __vue_component__$2,
  TextareaInput: __vue_component__$1,
  UpDownNav: __vue_component__
};
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(TaggingComponents);
}
var TaggingComponents$1 = {
  ...TaggingComponents
};

function removeRepeatingKeys(repeatingData) {
  const copyRepeatingData = [...repeatingData];
  copyRepeatingData.forEach(repeating => {
    delete repeating.repeatingKey;
  });
  return copyRepeatingData;
}

function countableType(item) {
  if (isSuggestedCountable(item)) {
    return 'Pendo Suggested';
  }
  if (isInheritedCountable(item)) {
    return 'Inherited';
  }
  if (isInactiveCountable(item)) {
    return 'Inactive';
  }
  if (isAutomaticCountable(item)) {
    return 'Automatic';
  }
  return 'Custom';
}
function isCustomCountable(item) {
  return isString$1(get$1(item, 'rootVersionId', false)) && !get$1(item, 'id', '').includes('auto');
}
function isInactiveCountable(item) {
  return !get$1(item, 'trainingSettings.enabled', false) && !isString$1(get$1(item, 'rootVersionId', false)) && !get$1(item, 'id', '').includes('auto');
}
function isInheritedCountable(item) {
  return get$1(item, 'trainingSettings.enabled', false) && !isString$1(get$1(item, 'rootVersionId', false)) && !get$1(item, 'id', '').includes('auto');
}
function isSuggestedCountable(item) {
  return (get$1(item, 'isSuggested', false) || get$1(item, 'isAutoTagged', false)) && isEmpty$1(get$1(item, 'trainingSettings', {})) && !get$1(item, 'id', '').includes('auto');
}
function isAutomaticCountable(item) {
  return get$1(item, 'id', '').includes('auto');
}
function canEditCountable(item, aeu = false) {
  const editableCountables = ['Pendo Suggested', 'Automatic', 'Custom'];
  const aeuEditableCountables = ['Custom'];
  const type = countableType(item);
  return aeu ? aeuEditableCountables.includes(type) : editableCountables.includes(type);
}
function canDeleteCountable(item, aeu = false) {
  const deletableCountables = ['Pendo Suggested', 'Inactive', 'Automatic', 'Custom'];
  const aeuDeletableCountables = ['Custom'];
  const type = countableType(item);
  return aeu ? aeuDeletableCountables.includes(type) : deletableCountables.includes(type);
}

/**
 * Checks if a feature name is already in use.
 * @param {string} name - The feature name to check.
 * @param {Array} features - The list of existing features.
 * @returns {boolean} True if the feature name is in use, false otherwise.
 */
function isNameInUse(name, features) {
  return features.some(feature => feature.name === name);
}

/**
 * Returns a function that validates a feature name. We need to pass the original name of the feature and a list of features to validate against through to the validator that will be used in the form.
 * @param {Array} features - The list of existing features.
 * @param {string} originalName - The original name of the feature if it is being edited, or an empty string if it is a new feature.
 * @returns {function} - A callback function for validating the feature name.
 */
function validateFeatureName({
  features,
  originalName
}) {
  return (rule, name, callback) => {
    if (name === '') {
      return callback(new Error('Name is required.'));
    }
    if (name !== originalName && isNameInUse(name, features)) {
      return callback(new Error('This feature name is already in use. Try another?'));
    }
    return callback();
  };
}

const TaggingUtils = {
  removeRepeatingKeys,
  countableType,
  isCustomCountable,
  isInheritedCountable,
  isInactiveCountable,
  isSuggestedCountable,
  isAutomaticCountable,
  canEditCountable,
  canDeleteCountable,
  validateFeatureName
};
var TaggingUtils$1 = {
  ...TaggingUtils
};

var index = {
  ...TaggingAggregations$1,
  ...TaggingComponents$1,
  ...TaggingUtils$1
};

export { __vue_component__$g as CollapseDetails, __vue_component__$d as ConfigureSelector, __vue_component__$c as CountableTableExpander, __vue_component__$b as CountableTableRules, __vue_component__$8 as CustomRuleBuilder, __vue_component__$7 as FeaturesButton, __vue_component__$6 as PageRuleTester, __vue_component__$5 as PagesButton, __vue_component__$4 as RepeatingComponent, __vue_component__$f as SelectorEditor, SuggestedPagesLoadEventsAggregation, __vue_component__$3 as SuggestedPagesTable, __vue_component__$2 as TaggingOnIngestionSettings, __vue_component__$1 as TextareaInput, __vue_component__ as UpDownNav, canDeleteCountable, canEditCountable, countableType, index as default, install, isAutomaticCountable, isCustomCountable, isInactiveCountable, isInheritedCountable, isSuggestedCountable, removeRepeatingKeys, validateFeatureName };
